import React, { useState, useEffect, useRef, useCallback } from "react";
import "./HeadJob.css";
import { Link, useNavigate } from "react-router-dom";
import CompanyBalls from "./Company_balls/Company_balls";
import { useAuth } from "../../../../context/Authcontext";
import { INTERVIEW_DATA } from "../../InterviewQuestions/INTERVIEW_DATA.js";
import PropTypes from "prop-types";

/* ═══════════════════════════════
   PROFESSIONAL SVG ICONS
═══════════════════════════════ */
const Icons = {
  Search: ({ size = 20, color = "currentColor", animated = false }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={animated ? "icon-animated icon-search" : ""}>
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ),
  Briefcase: ({ size = 20, color = "currentColor", animated = false }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={animated ? "icon-animated icon-briefcase" : ""}>
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  MapPin: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  ),
  Award: ({ size = 20, color = "currentColor", animated = false }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={animated ? "icon-animated icon-award" : ""}>
      <circle cx="12" cy="8" r="6" />
      <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11" />
    </svg>
  ),
  TrendingUp: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
      <polyline points="17 6 23 6 23 12" />
    </svg>
  ),
  FileText: ({ size = 20, color = "currentColor", animated = false }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={animated ? "icon-animated icon-file" : ""}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  Target: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="6" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  ),
  Shield: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  Zap: ({ size = 20, color = "currentColor", animated = false }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={animated ? "icon-animated icon-zap" : ""}>
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  ),
  Users: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  Star: ({ size = 20, color = "currentColor", filled = false }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={filled ? color : "none"} stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  Gift: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 12 20 22 4 22 4 12" />
      <rect x="2" y="7" width="20" height="5" />
      <line x1="12" y1="22" x2="12" y2="7" />
      <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
    </svg>
  ),
  DollarSign: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
    </svg>
  ),
  ArrowRight: ({ size = 16, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  ),
  Lock: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  ),
  CheckCircle: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  Code: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="16 18 22 12 16 6" />
      <polyline points="8 6 2 12 8 18" />
    </svg>
  ),
  Cpu: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="4" width="16" height="16" rx="2" ry="2" /><rect x="9" y="9" width="6" height="6" />
      <line x1="9" y1="1" x2="9" y2="4" /><line x1="15" y1="1" x2="15" y2="4" />
      <line x1="9" y1="20" x2="9" y2="23" /><line x1="15" y1="20" x2="15" y2="23" />
      <line x1="20" y1="9" x2="23" y2="9" /><line x1="20" y1="14" x2="23" y2="14" />
      <line x1="1" y1="9" x2="4" y2="9" /><line x1="1" y1="14" x2="4" y2="14" />
    </svg>
  ),
  BarChart: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" />
      <line x1="2" y1="20" x2="22" y2="20" />
    </svg>
  ),
  Palette: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="13.5" cy="6.5" r=".5" fill={color} /><circle cx="17.5" cy="10.5" r=".5" fill={color} />
      <circle cx="8.5" cy="7.5" r=".5" fill={color} /><circle cx="6.5" cy="12.5" r=".5" fill={color} />
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
    </svg>
  ),
  Cloud: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
    </svg>
  ),
  Smartphone: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
      <line x1="12" y1="18" x2="12.01" y2="18" />
    </svg>
  ),
  MessageCircle: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
  Calculator: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="2" width="16" height="20" rx="2" /><line x1="8" y1="6" x2="16" y2="6" />
      <line x1="8" y1="10" x2="8" y2="10" strokeWidth="2.5" /><line x1="12" y1="10" x2="12" y2="10" strokeWidth="2.5" /><line x1="16" y1="10" x2="16" y2="10" strokeWidth="2.5" />
      <line x1="8" y1="14" x2="8" y2="14" strokeWidth="2.5" /><line x1="12" y1="14" x2="12" y2="14" strokeWidth="2.5" /><line x1="16" y1="14" x2="16" y2="14" strokeWidth="2.5" />
      <line x1="8" y1="18" x2="12" y2="18" strokeWidth="2.5" /><line x1="16" y1="18" x2="16" y2="18" strokeWidth="2.5" />
    </svg>
  ),
  Ticket: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/>
      <line x1="9" y1="12" x2="15" y2="12" />
    </svg>
  ),
  CreditCard: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
      <line x1="1" y1="10" x2="23" y2="10" />
    </svg>
  ),
  Trophy: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="14 11 14 10 10 10 10 11" />
      <path d="M17 5V3H7v2M7 5c0 3.3 2.2 6 5 6s5-2.7 5-6" />
      <path d="M7 5H4l1 8h2M17 5h3l-1 8h-2" />
      <line x1="9" y1="19" x2="15" y2="19" />
      <line x1="12" y1="16" x2="12" y2="19" />
      <line x1="9" y1="22" x2="15" y2="22" />
    </svg>
  ),
  Clock: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  BookOpen: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
    </svg>
  ),
  RefreshCw: ({ size = 20, color = "currentColor" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  ),
};

/* ═══════════════════════════════
   API BASE
═══════════════════════════════ */
const API_BASE = "/api";

/* ═══════════════════════════════
   COURSE ICON MAP
═══════════════════════════════ */
const COURSE_ICON_MAP = {
  development: "Code", web: "Code", frontend: "Code", backend: "Code",
  react: "Code", node: "Code", javascript: "Code", python: "Code",
  java: "Code", fullstack: "Code", "full stack": "Code",
  "machine learning": "Cpu", ml: "Cpu", ai: "Cpu", "artificial intelligence": "Cpu",
  "deep learning": "Cpu", nlp: "Cpu",
  "data science": "BarChart", data: "BarChart", analytics: "BarChart", sql: "BarChart",
  tableau: "BarChart", excel: "BarChart",
  design: "Palette", "ui/ux": "Palette", ux: "Palette", figma: "Palette",
  cloud: "Cloud", aws: "Cloud", azure: "Cloud", gcp: "Cloud", devops: "Cloud",
  mobile: "Smartphone", android: "Smartphone", ios: "Smartphone", flutter: "Smartphone",
  "react native": "Smartphone",
  career: "TrendingUp", marketing: "TrendingUp", business: "TrendingUp",
  "digital marketing": "TrendingUp",
  cybersecurity: "Shield", security: "Shield", ethical: "Shield",
  blockchain: "Zap", crypto: "Zap",
};

function pickCourseIcon(course) {
  const haystack = [
    course.category || "",
    ...(course.tags || []),
    course.title || "",
  ].join(" ").toLowerCase();

  for (const [keyword, icon] of Object.entries(COURSE_ICON_MAP)) {
    if (haystack.includes(keyword)) return icon;
  }
  return "BookOpen";
}

const CATEGORY_COLOR_MAP = {
  development: "#263012", web: "#263012", "data science": "#1d4ed8",
  design: "#7c3aed", cloud: "#0369a1", mobile: "#059669",
  career: "#d97706", marketing: "#dc2626", cybersecurity: "#374151",
  ai: "#4f46e5", "machine learning": "#4f46e5", blockchain: "#b45309",
};

function pickCourseColor(course) {
  const cat = (course.category || "").toLowerCase();
  for (const [key, color] of Object.entries(CATEGORY_COLOR_MAP)) {
    if (cat.includes(key)) return color;
  }
  return "#263012";
}

const fmtNum = (n) => {
  const num = Number(n) || 0;
  if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  return String(num);
};

function fmtDuration(raw) {
  if (!raw) return null;
  if (typeof raw === "string" && /[hm]/.test(raw)) return raw;
  const mins = Number(raw);
  if (!mins || Number.isNaN(mins)) return raw;
  const h = Math.floor(mins / 60);
  const m = mins % 60;
  if (h && m) return `${h}h ${m}m`;
  if (h) return `${h}h`;
  return `${m}m`;
}

/* ─────────────────────────────────────────────
   useLatestCourses
─────────────────────────────────────────────── */
function useLatestCourses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tick, setTick] = useState(0);

  const retry = useCallback(() => setTick(t => t + 1), []);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);

    async function load() {
      const endpoints = [
        `${API_BASE}/courses?sort=newest&limit=6`,
        `${API_BASE}/courses?sort=recent&limit=6`,
        `${API_BASE}/courses?limit=6`,
      ];

      let lastErr = null;

      for (const url of endpoints) {
        try {
          const res = await fetch(url);
          if (!res.ok) { lastErr = `HTTP ${res.status}`; continue; }
          const json = await res.json();
          const raw = Array.isArray(json)
            ? json
            : Array.isArray(json.courses)
              ? json.courses
              : Array.isArray(json.data)
                ? json.data
                : [];

          if (!active) return;
          setCourses(raw.slice(0, 6));
          setError(null);
          setLoading(false);
          return;
        } catch (e) {
          lastErr = e.message;
        }
      }

      if (active) {
        setError(lastErr || "Failed to load courses");
        setLoading(false);
      }
    }

    load();
    return () => { active = false; };
  }, [tick]);

  return { courses, loading, error, retry };
}

function usePopularRoles() {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    async function load() {
      try {
        const res = await fetch(`${API_BASE}/jobs/popular-roles?limit=12`);
        if (res.ok) {
          const json = await res.json();
          const raw = Array.isArray(json) ? json
            : Array.isArray(json.data) ? json.data
            : Array.isArray(json.roles) ? json.roles : [];
          if (active && raw.length > 0) {
            setRoles(raw.map(r => ({
              icon: pickRoleIcon(r.title || r.role || r.job_title || ""),
              role: r.title || r.role || r.job_title || "Role",
              count: `${Number(r.count || r.job_count || r.total || 0).toLocaleString()}+ openings`,
              rawCount: Number(r.count || r.job_count || r.total || 0),
            })));
            setLoading(false);
            return;
          }
        }
        const res2 = await fetch(`${API_BASE}/jobs?limit=200&status=active`);
        if (!res2.ok) throw new Error("jobs fetch failed");
        const json2 = await res2.json();
        const jobs = Array.isArray(json2) ? json2
          : Array.isArray(json2.data) ? json2.data
          : Array.isArray(json2.jobs) ? json2.jobs : [];

        const countMap = {};
        jobs.forEach(j => {
          const rawTitle = (j.title || j.job_title || "").trim();
          if (!rawTitle) return;
          const words = rawTitle.split(/\s+/);
          const key = words.slice(0, 3).join(" ");
          countMap[key] = (countMap[key] || 0) + 1;
        });

        const sorted = Object.entries(countMap)
          .sort((a, b) => b[1] - a[1])
          .slice(0, 12)
          .map(([title, count]) => ({
            icon: pickRoleIcon(title),
            role: title,
            count: `${count}+ openings`,
            rawCount: count,
          }));

        if (active) {
          setRoles(sorted.length > 0 ? sorted : ROLES_FALLBACK);
          setLoading(false);
        }
      } catch {
        if (active) { setRoles(ROLES_FALLBACK); setLoading(false); }
      }
    }
    load();
    return () => { active = false; };
  }, []);

  return { roles, loading };
}

function useSponsors() {
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    async function load() {
      try {
        const res = await fetch(`${API_BASE}/companies?limit=16&sort=jobs&page=1`);
        if (!res.ok) throw new Error("companies fetch failed");
        const json = await res.json();
        const raw = Array.isArray(json) ? json
          : Array.isArray(json.data) ? json.data
          : Array.isArray(json.companies) ? json.companies : [];

        if (active) {
          setSponsors(raw.slice(0, 16).map((co, i) => {
            const name = co.company_name || co.name || "Company";
            const jobs = Number(co.active_jobs || co.total_jobs || co.job_count || 0);
            const badge = jobs > 1000 ? "Hot" : jobs > 500 ? "Hiring" : jobs > 200 ? "Urgent" : "New";
            return {
              letter: name.trim()[0].toUpperCase(),
              bg: SPONSOR_COLORS[i % SPONSOR_COLORS.length],
              name,
              logo: co.company_logo || co.logo || null,
              jobs: `${jobs.toLocaleString()}+ jobs`,
              badge,
            };
          }));
          setLoading(false);
        }
      } catch {
        if (active) { setSponsors(SPONSORS_FALLBACK); setLoading(false); }
      }
    }
    load();
    return () => { active = false; };
  }, []);

  return { sponsors, loading };
}

const ROLES_FALLBACK = [
  { icon: "Code", role: "Software Engineer", count: "72K+ openings" },
  { icon: "BarChart", role: "Data Analyst", count: "18K+ openings" },
  { icon: "Palette", role: "UX/UI Designer", count: "9K+ openings" },
  { icon: "TrendingUp", role: "Digital Marketing", count: "24K+ openings" },
  { icon: "DollarSign", role: "Finance Analyst", count: "11K+ openings" },
  { icon: "Cloud", role: "Cloud Architect", count: "6K+ openings" },
  { icon: "Cpu", role: "ML Engineer", count: "8K+ openings" },
  { icon: "Target", role: "Product Manager", count: "13K+ openings" },
  { icon: "Shield", role: "Cybersecurity", count: "4K+ openings" },
  { icon: "Smartphone", role: "Mobile Developer", count: "16K+ openings" },
  { icon: "Users", role: "HR Manager", count: "19K+ openings" },
  { icon: "Zap", role: "DevOps Engineer", count: "10K+ openings" },
];

const SPONSORS_FALLBACK = [
  { letter: "I", bg: "#6200ea", name: "Infosys", jobs: "1,800+ jobs", badge: "Urgent" },
  { letter: "H", bg: "#d32f2f", name: "HCL Tech", jobs: "3,100+ jobs", badge: "Hot" },
  { letter: "C", bg: "#1a73e8", name: "Cognizant", jobs: "1,500+ jobs", badge: "Hiring" },
  { letter: "O", bg: "#12160a", name: "Oracle", jobs: "820+ jobs", badge: "New" },
  { letter: "D", bg: "#00c853", name: "Deloitte", jobs: "960+ jobs", badge: "Premium" },
  { letter: "A", bg: "#333333", name: "Accenture", jobs: "4,200+ jobs", badge: "Urgent" },
  { letter: "P", bg: "#e91e63", name: "Paytm", jobs: "640+ jobs", badge: "New" },
  { letter: "W", bg: "#0078d4", name: "Wipro", jobs: "1,800+ jobs", badge: "Urgent" },
];

/* ─────────────────────────────────────────────
   CourseSkeleton
─────────────────────────────────────────────── */
function CourseSkeleton() {
  return (
    <div className="th-courses-grid">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={`skel-${i}`} className="th-course-card" style={{ pointerEvents: "none" }}
          data-aos={i % 2 === 0 ? "fade-right" : "fade-left"}
          data-aos-delay={i * 70}>
          <div className="th-course-thumb cc-skel" style={{ height: 116 }} />
          <div className="th-course-body">
            <div className="cc-skel" style={{ width: "35%", height: 18, borderRadius: 6, marginBottom: 10 }} />
            <div className="cc-skel" style={{ width: "90%", height: 14, borderRadius: 6, marginBottom: 7 }} />
            <div className="cc-skel" style={{ width: "70%", height: 13, borderRadius: 6, marginBottom: 14 }} />
            <div style={{ display: "flex", gap: 10 }}>
              <div className="cc-skel" style={{ width: "40%", height: 12, borderRadius: 6 }} />
              <div className="cc-skel" style={{ width: "30%", height: 12, borderRadius: 6 }} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

/* ─────────────────────────────────────────────
   CourseThumbnail — extracted out of parent render
─────────────────────────────────────────────── */
function CourseThumbnail({ c, cardColor, title, CardIcon }) {
  return (
    <div
      className="th-course-thumb"
      style={{ background: `linear-gradient(135deg, ${cardColor}12, ${cardColor}22)` }}
    >
      {(c.banner || c.thumbnail || c.image) ? (
        <img
          src={c.banner ?? c.thumbnail ?? c.image}
          alt={title}
          style={{ width: "100%", height: "100%", objectFit: "cover", position: "absolute", inset: 0 }}
          loading="lazy"
          onError={e => { e.target.style.display = "none"; }}
        />
      ) : (
        <span className="th-course-thumb-icon">
          {CardIcon && <CardIcon size={44} color={cardColor} />}
        </span>
      )}
      <div className="th-course-thumb-fade" />
    </div>
  );
}

CourseThumbnail.propTypes = {
  c: PropTypes.shape({
    banner: PropTypes.string,
    thumbnail: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  cardColor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  CardIcon: PropTypes.elementType,
};

CourseThumbnail.defaultProps = {
  CardIcon: null,
};

/* ─────────────────────────────────────────────
   TopCoursesSection
─────────────────────────────────────────────── */
function TopCoursesSection({ navigate }) {
  const { courses, loading, error, retry } = useLatestCourses();

  return (
    <section className="th-section th-section--white head-th-slide">
      <div className="th-container">
        <div className="th-sh" data-aos="fade-up" data-aos-delay="0">
          <h2 className="th-sh-title">
            Upskill With <span className="th-grad">Top Courses</span>
          </h2>
        </div>

        <CourseSearchBar
          onSearch={q => navigate(`/employee/courses?search=${encodeURIComponent(q)}`)}
        />

        {loading && <CourseSkeleton />}

        {!loading && error && (
          <div style={{
            textAlign: "center", padding: "48px 20px",
            background: "#fafafa", borderRadius: 16,
            border: "1px solid #f0f0f0"
          }}>
            <div style={{ fontSize: "2.4rem", marginBottom: 12 }}>📚</div>
            <div style={{ fontWeight: 700, color: "#111827", fontSize: "1rem", marginBottom: 6 }}>
              Could not load courses right now
            </div>
            <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: 20 }}>
              {error}
            </div>
            <button
              onClick={retry}
              style={{
                display: "inline-flex", alignItems: "center", gap: 7,
                background: "#263012", color: "#fff", border: "none",
                borderRadius: 10, padding: "10px 22px",
                fontWeight: 700, fontSize: "0.85rem", cursor: "pointer"
              }}
            >
              <Icons.RefreshCw size={14} color="#fff" /> Try Again
            </button>
          </div>
        )}

        {!loading && !error && courses.length > 0 && (
          <div className="th-courses-grid">
            {courses.map((c, i) => {
              const iconName  = pickCourseIcon(c);
              const CardIcon  = Icons[iconName];
              const cardColor = pickCourseColor(c);
              const courseLink = `/employee/courses-main/${c.id}`;

              const studentCount = fmtNum(c.enrolled_count ?? c.enrolled ?? c.students ?? 0);
              const duration     = fmtDuration(c.duration) || "Self-paced";
              const rating       = Number.parseFloat(c.rating || c.avg_rating || 0).toFixed(1);
              const reviews      = fmtNum(c.reviews_count ?? c.reviews ?? c.total_reviews ?? 0);
              const originalPrice = c.original_price ?? c.originalPrice ?? c.mrp;
              const price        = c.price ?? c.discounted_price ?? 0;
              const isFree       = Number(price) === 0;
              const badge        = c.badge ?? (c.featured ? "Featured" : i === 0 ? "New" : null);
              const tag          = c.category ?? c.tag ?? "Course";
              const title        = c.title ?? c.name ?? "Untitled Course";

              return (
                <Link
                  key={c.id || `course-${i}`}
                  to={courseLink}
                  className="th-course-card-link"
                  style={{ textDecoration: "none", display: "block" }}
                >
                  <div
                    className="th-course-card"
                    data-aos={i % 2 === 0 ? "fade-right" : "fade-left"}
                    data-aos-delay={i * 75}
                  >
                    {badge && (
                      <div className="th-course-badge" style={{ background: cardColor }}>
                        {badge}
                      </div>
                    )}

                    <CourseThumbnail c={c} cardColor={cardColor} title={title} CardIcon={CardIcon} />

                    <div className="th-course-body">
                      <span
                        className="th-course-tag"
                        style={{ background: `${cardColor}18`, color: cardColor }}
                      >
                        {tag}
                      </span>

                      <div className="th-course-title">{title}</div>

                      <div className="th-course-meta">
                        <span>
                          <Icons.Users size={12} color="#9ca3af" /> {studentCount} students
                        </span>
                        <span>
                          <Icons.Clock size={12} color="#9ca3af" /> {duration}
                        </span>
                      </div>

                      <div className="th-course-footer">
                        <div className="th-course-price-wrap">
                          {originalPrice && Number(originalPrice) > 0 && (
                            <s className="th-course-price-original">
                              ₹{Number(originalPrice).toLocaleString()}
                            </s>
                          )}
                          {isFree
                            ? <span className="th-course-price-free">FREE</span>
                            : <span className="th-course-price-cur" style={{ color: cardColor }}>
                                ₹{Number(price).toLocaleString()}
                              </span>
                          }
                        </div>
                        {Number(rating) > 0 && (
                          <span className="th-course-rating">
                            <Icons.Star size={12} color="#f59e0b" filled /> {rating}
                            {Number(reviews) > 0 && ` (${reviews})`}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="th-course-card__shine" />
                  </div>
                </Link>
              );
            })}
          </div>
        )}

        {!loading && !error && courses.length === 0 && (
          <div style={{ textAlign: "center", padding: "48px 20px", color: "#6b7280" }}>
            <div style={{ fontSize: "2.4rem", marginBottom: 12 }}>📚</div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>No courses posted yet</div>
            <div style={{ fontSize: "0.88rem" }}>Check back soon — new courses are added regularly.</div>
          </div>
        )}

        <div
          style={{ textAlign: "center", marginTop: 40 }}
          data-aos="fade-up"
          data-aos-delay="160"
        >
          <ShimmerBtn
            onClick={() => navigate("/employee/courses")}
            style={{ fontSize: ".95rem", padding: "14px 36px" }}
          >
            Explore All Courses →
          </ShimmerBtn>
        </div>
      </div>
    </section>
  );
}

TopCoursesSection.propTypes = {
  navigate: PropTypes.func.isRequired,
};

/* ═══════════════════════════════
   DATA
═══════════════════════════════ */
const POPULAR_CITIES = [
  { name: "Bangalore", emoji: "🏙️" },{ name: "Mumbai", emoji: "🌆" },
  { name: "Delhi", emoji: "🏛️" },{ name: "Hyderabad", emoji: "💻" },
  { name: "Pune", emoji: "🎓" },{ name: "Chennai", emoji: "🌊" },
  { name: "Kolkata", emoji: "🎭" },{ name: "Ahmedabad", emoji: "🏗️" },
  { name: "Remote", emoji: "🌐" },{ name: "Noida", emoji: "🏢" },
  { name: "Gurgaon", emoji: "🏙️" },{ name: "Jaipur", emoji: "🏰" },
];

const SALARY_DB_POSITIONS = [
  "Software Engineer","Senior Software Engineer","Staff Engineer","Principal Engineer",
  "Product Manager","Senior Product Manager","Director of Product",
  "Data Scientist","Senior Data Scientist","Lead Data Scientist",
  "Data Analyst","Business Intelligence Analyst","Data Engineer",
  "UI/UX Designer","Senior Designer","Design Lead","Visual Designer",
  "DevOps Engineer","Site Reliability Engineer","Platform Engineer",
  "Business Analyst","Systems Analyst","Enterprise Architect",
  "Marketing Manager","Growth Manager","Digital Marketing Lead",
  "Financial Analyst","Investment Analyst","Finance Manager",
  "Full Stack Developer","Frontend Developer","Backend Developer",
  "Machine Learning Engineer","AI Researcher","NLP Engineer",
];

const SALARY_DB_CITIES = [
  { name: "Bangalore", emoji: "🏙️" },{ name: "Mumbai", emoji: "🌆" },
  { name: "Delhi", emoji: "🏛️" },{ name: "Hyderabad", emoji: "💻" },
  { name: "Pune", emoji: "🎓" },{ name: "Chennai", emoji: "🌊" },
  { name: "Kolkata", emoji: "🎭" },{ name: "Ahmedabad", emoji: "🏗️" },
  { name: "Remote", emoji: "🌐" },{ name: "Noida", emoji: "🏢" },
  { name: "Gurgaon", emoji: "🏙️" },{ name: "Jaipur", emoji: "🏰" },
  { name: "Lucknow", emoji: "🕌" },{ name: "Surat", emoji: "💎" },
  { name: "Nagpur", emoji: "🍊" },{ name: "Coimbatore", emoji: "🏭" },
];

const COURSE_SEARCH_DB = [
  "Full Stack Web Development","React.js Masterclass","Node.js Backend Development",
  "Machine Learning with Python","Deep Learning & Neural Networks","NLP Fundamentals",
  "Data Science Bootcamp","Python for Data Analysis","SQL & Database Design",
  "UI/UX Design Principles","Figma for Designers","AWS Cloud Practitioner",
  "Google Cloud Professional","Azure Fundamentals","DevOps with Docker & Kubernetes",
  "React Native App Development","Flutter Cross-Platform","iOS Development with Swift",
  "Cybersecurity Fundamentals","Ethical Hacking","Blockchain Development",
  "Digital Marketing Strategy","Financial Modeling","Product Management","Agile & Scrum",
];

const TOOLS = [
  { id: "hr-talks", label: "Career Talks", sublabel: "Talk to HR", icon: "MessageCircle", path: "/employee/hrtalk", desc: "Talk to HR and clear all your doubts.", strip: "Talk to real HRs & get doubts cleared" },
  { id: "resume-builder", label: "Resume Builder", sublabel: "Build & Download", icon: "FileText", path: "/employee/resume-builder", desc: "Build your customized resume.", strip: "Build, customize & download your resume" },
  { id: "ats-checker", label: "ATS Checker", sublabel: "Beat the Bots", icon: "Shield", path: "/employee/ats-score-checker", desc: "Check your ATS resume score instantly.", strip: "Get your ATS score instantly for free" },
  { id: "calculator", label: "Calculators", sublabel: "Open navbar menu", icon: "Calculator", path: null, desc: "Open the calculator menu in the navbar.", isDropdown: true, strip: "Multiple calculators available in menu" },
];

const ALL_COMPANIES_POOL = [
  { letter: "G", bg: "#4285f4", name: "Google", jobs: "200+ jobs" },
  { letter: "M", bg: "#0078d4", name: "Microsoft", jobs: "150+ jobs" },
  { letter: "A", bg: "#12160a", name: "Amazon", jobs: "320+ jobs" },
  { letter: "N", bg: "#E50914", name: "Netflix", jobs: "90+ jobs" },
  { letter: "M", bg: "#1a47d8", name: "Meta", jobs: "180+ jobs" },
  { letter: "A", bg: "#A259FF", name: "Adobe", jobs: "75+ jobs" },
  { letter: "S", bg: "#00A1E0", name: "Salesforce", jobs: "120+ jobs" },
  { letter: "I", bg: "#0668E1", name: "IBM", jobs: "400+ jobs" },
  { letter: "Z", bg: "#d32f2f", name: "Zomato", jobs: "45+ jobs" },
  { letter: "P", bg: "#00c853", name: "PhonePe", jobs: "80+ jobs" },
  { letter: "I", bg: "#6200ea", name: "Infosys", jobs: "500+ jobs" },
  { letter: "F", bg: "#e44d26", name: "Flipkart", jobs: "210+ jobs" },
  { letter: "S", bg: "#ff6900", name: "Swiggy", jobs: "65+ jobs" },
  { letter: "T", bg: "#1a73e8", name: "TCS", jobs: "600+ jobs" },
  { letter: "W", bg: "#5c068c", name: "Wipro", jobs: "280+ jobs" },
];

const SALARY_CHIPS = ["Software Engineer","Product Manager","Data Scientist","UI/UX Designer","DevOps Engineer"];

const SPONSOR_COLORS = [
  "#6200ea","#0078d4","#d32f2f","#1a73e8","#12160a",
  "#00c853","#333333","#e91e63","#f57c00","#0097a7",
];

const ER_REWARD_CARDS = [
  { id: "referral_signup_complete", icon: "Users", label: "Referral Signup Complete", pts: 100, goalPts: 500, color: "#6366f1", bg: "linear-gradient(135deg,#eef2ff,#f5f3ff)", path: "/employee/profile" },
  { id: "interview_offer_verified", icon: "FileText", label: "Verified Offer Letter", pts: 200, goalPts: 600, color: "#10b981", bg: "linear-gradient(135deg,#ecfdf5,#d1fae5)", path: "/employee/profile" },
  { id: "positive_rating", icon: "Star", label: "Positive Ratings", pts: 5, goalPts: 100, color: "#f59e0b", bg: "linear-gradient(135deg,#fffbeb,#fef3c7)", path: "/employee/profile" },
  { id: "profile_complete_100", icon: "CheckCircle", label: "Profile 100% Complete", pts: 100, goalPts: 100, color: "#14b8a6", bg: "linear-gradient(135deg,#f0fdfa,#ccfbf1)", path: "/employee/profile" },
];

const ER_LEADERBOARD = [
  { name: "Aryan S.", pts: 4820, ava: "AS", bg: "#ededfa", medal: "🥇" },
  { name: "Priya M.", pts: 4210, ava: "PM", bg: "#edf5ed", medal: "🥈" },
  { name: "Rohan K.", pts: 3990, ava: "RK", bg: "#f5edf5", medal: "🥉" },
  { name: "Sneha P.", pts: 3450, ava: "SP", bg: "#edf5f5", medal: "4th" },
  { name: "You", pts: 2450, ava: "ME", bg: "#eeeeff", medal: "5th", isMe: true },
];

const ER_STREAK = ["M","T","W","T","F","S","S"];
const ER_ACTIVITY = [
  { label: "Referral signup completed", pts: "+100", time: "Rule based", accent: "#6366f1", icon: "Users" },
  { label: "Verified offer letter approved", pts: "+200", time: "Within 48h", accent: "#10b981", icon: "FileText" },
  { label: "Positive rating received", pts: "+5", time: "Per rating", accent: "#f59e0b", icon: "Star" },
  { label: "Profile reached 100%", pts: "+100", time: "One-time", accent: "#14b8a6", icon: "CheckCircle" },
];

const toNum = (val, fallback = 0) => { const n = Number(val); return Number.isFinite(n) ? n : fallback; };
const clampPct = (val) => Math.max(0, Math.min(100, Math.round(toNum(val, 0))));
const firstFinite = (obj, keys, fallback = 0) => { for (const key of keys) { const value = obj?.[key]; if (Number.isFinite(Number(value))) return Number(value); } return fallback; };
const readAuthToken = () => { try { return localStorage.getItem("token") || localStorage.getItem("th_token") || ""; } catch { return ""; } };

const buildFallbackRewardsData = (authUser) => {
  const name = authUser?.full_name || authUser?.name || "User";
  const initials = name.split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase() || "ME";
  const fallbackLeaderboard = [...ER_LEADERBOARD];
  const meIdx = fallbackLeaderboard.findIndex((r) => r.isMe || r.name === "You");
  if (meIdx >= 0) {
    fallbackLeaderboard[meIdx] = { ...fallbackLeaderboard[meIdx], name: "You", ava: initials, isMe: true, pts: toNum(fallbackLeaderboard[meIdx].pts, 0) };
  } else {
    fallbackLeaderboard.push({ name: "You", pts: 0, ava: initials, bg: "#eeeeff", medal: "—", isMe: true });
  }
  return {
    userName: name, userPts: 0, userRank: "—", streakCount: 0,
    streakDone: ER_STREAK.map(() => false), leaderboard: fallbackLeaderboard,
    activity: ER_ACTIVITY,
    rewardCards: ER_REWARD_CARDS.map((c) => ({ ...c, pct: 0, progressText: `0 earned · +${toNum(c.pts, 0).toLocaleString()} per rule` })),
    source: "fallback"
  };
};

const asArray = (val) => {
  if (Array.isArray(val)) return val;
  if (typeof val === "string") {
    const t = val.trim();
    if (!t) return [];
    try {
      const parsed = JSON.parse(t);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return t.split(",").map((s) => s.trim()).filter(Boolean);
    }
  }
  return [];
};

const getProfileCompletionStatus = (profile) => {
  const skills = asArray(profile?.skills);
  const education = Array.isArray(profile?.education) ? profile.education : asArray(profile?.education);
  const fullNameOk = Boolean(profile?.first_name && profile?.last_name);
  const required = [
    fullNameOk, Boolean(profile?.email), Boolean(profile?.mobile),
    Boolean(profile?.headline), Boolean(profile?.resume_url),
    Boolean(profile?.country_iso), Boolean(profile?.gender),
    Boolean(profile?.aadhar), Boolean(profile?.pan),
    education.length > 0, skills.length >= 3,
  ];
  const done = required.filter(Boolean).length;
  const total = required.length;
  const pct = Math.round((done / Math.max(total, 1)) * 100);
  return { isComplete: done === total, pct };
};

const computeRewardMetrics = (profile, applications, ratings) => {
  const referralCount = Math.max(0, firstFinite(profile, ["referral_signup_count","referral_completed_count","successful_referrals","referrals_count","total_referrals","referral_count"], 0));
  let offerVerifiedCount = firstFinite(profile, ["offer_letter_verified_count","verified_offer_count","offers_verified","verified_offers_count","offer_verified_count"], -1);
  if (offerVerifiedCount < 0) {
    const offerStatuses = new Set(["hired","selected","offer_accepted","joined","offer_received"]);
    offerVerifiedCount = (applications || []).filter((a) => offerStatuses.has(String(a?.status || "").toLowerCase())).length;
  }
  offerVerifiedCount = Math.max(0, offerVerifiedCount);
  let positiveRatingsCount = firstFinite(profile, ["positive_rating_count","positive_ratings_count"], -1);
  if (positiveRatingsCount < 0) {
    positiveRatingsCount = (ratings || []).filter((r) => toNum(r?.overall_rating, 0) >= 4).length;
  }
  positiveRatingsCount = Math.max(0, positiveRatingsCount);
  const profileStatus = getProfileCompletionStatus(profile);
  const profileCompleteCount = profileStatus.isComplete ? 1 : 0;
  const referralPts = referralCount * 100;
  const offerPts = offerVerifiedCount * 200;
  const ratingPts = positiveRatingsCount * 5;
  const profilePts = profileCompleteCount * 100;
  return {
    referralCount, offerVerifiedCount, positiveRatingsCount, profileCompleteCount,
    profileCompletionPct: profileStatus.pct,
    totalPoints: referralPts + offerPts + ratingPts + profilePts,
    breakdown: { referralPts, offerPts, ratingPts, profilePts }
  };
};

const computeProfileScore = (profile, applications, ratings) => {
  const metrics = computeRewardMetrics(profile, applications, ratings);
  return metrics.totalPoints;
};

const buildProfileActivity = (_profile, _applications, _savedJobs, metrics) => {
  const items = [];
  if (toNum(metrics?.referralCount, 0) > 0) {
    items.push({ label: `Referral signup completed ×${metrics.referralCount}`, pts: `+${toNum(metrics?.breakdown?.referralPts, 0)}`, time: "Approved", accent: "#6366f1", icon: "Users" });
  }
  if (toNum(metrics?.offerVerifiedCount, 0) > 0) {
    items.push({ label: `Offer letter verified ×${metrics.offerVerifiedCount}`, pts: `+${toNum(metrics?.breakdown?.offerPts, 0)}`, time: "Team check in 48h", accent: "#10b981", icon: "FileText" });
  }
  if (toNum(metrics?.positiveRatingsCount, 0) > 0) {
    items.push({ label: `Positive ratings received ×${metrics.positiveRatingsCount}`, pts: `+${toNum(metrics?.breakdown?.ratingPts, 0)}`, time: "Per positive rating", accent: "#f59e0b", icon: "Star" });
  }
  if (toNum(metrics?.profileCompleteCount, 0) > 0) {
    items.push({ label: "Profile reached 100% completion", pts: "+100", time: "One-time", accent: "#14b8a6", icon: "CheckCircle" });
  }
  return items.slice(0, 5);
};

const buildRewardCardsFromMetrics = (metrics) => {
  return ER_REWARD_CARDS.map((card) => {
    const goal = Math.max(1, toNum(card?.goalPts, card?.pts));
    let earned = 0;
    let count = 0;
    let pct = 0;
    let progressText = "No activity yet";

    if (card.id === "referral_signup_complete") {
      count = toNum(metrics?.referralCount, 0);
      earned = toNum(metrics?.breakdown?.referralPts, 0);
      pct = clampPct((earned / goal) * 100);
      progressText = `${count} referral signup${count === 1 ? "" : "s"} · ${earned} pts earned`;
    } else if (card.id === "interview_offer_verified") {
      count = toNum(metrics?.offerVerifiedCount, 0);
      earned = toNum(metrics?.breakdown?.offerPts, 0);
      pct = clampPct((earned / goal) * 100);
      progressText = `${count} verified offer${count === 1 ? "" : "s"} · ${earned} pts earned`;
    } else if (card.id === "positive_rating") {
      count = toNum(metrics?.positiveRatingsCount, 0);
      earned = toNum(metrics?.breakdown?.ratingPts, 0);
      pct = clampPct((earned / goal) * 100);
      progressText = `${count} positive rating${count === 1 ? "" : "s"} · ${earned} pts earned`;
    } else if (card.id === "profile_complete_100") {
      count = toNum(metrics?.profileCompleteCount, 0);
      earned = toNum(metrics?.breakdown?.profilePts, 0);
      pct = count > 0 ? 100 : clampPct(toNum(metrics?.profileCompletionPct, 0));
      progressText = count > 0 ? "Profile 100% complete · 100 pts earned" : `Profile ${pct}% complete · 0 / 100 pts`;
    }

    return { ...card, pct, progressText, earnedPoints: earned, count };
  });
};

const buildRewardCardsFromScore = (userPts, metrics) => {
  if (metrics) return buildRewardCardsFromMetrics(metrics);
  return ER_REWARD_CARDS.map((card) => {
    const goal = Math.max(1, toNum(card?.goalPts, card?.pts));
    const progressPts = Math.min(userPts, goal);
    return { ...card, pct: clampPct((progressPts / goal) * 100), progressText: `${progressPts.toLocaleString()} / ${goal.toLocaleString()} points` };
  });
};

const buildLeaderboardWithUser = (userName, userPts) => {
  const initials = (userName || "User").split(" ").map((p) => p[0]).join("").slice(0, 2).toUpperCase() || "ME";
  const list = ER_LEADERBOARD.map((row) => ({ ...row, isMe: false }));
  list.push({ name: "You", pts: toNum(userPts, 0), ava: initials, bg: "#eeeeff", medal: "—", isMe: true });
  const sorted = list.toSorted((a, b) => toNum(b.pts) - toNum(a.pts));
  const medals = ["🥇","🥈","🥉","4th","5th","6th","7th","8th"];
  const normalized = sorted.slice(0, 7).map((row, i) => ({ ...row, medal: medals[i] || `${i + 1}th` }));
  const meIndex = normalized.findIndex((r) => r.isMe);
  return { leaderboard: normalized, rank: meIndex >= 0 ? meIndex + 1 : "—" };
};

const ROLES_ICON_MAP = {
  "software": "Code", "developer": "Code", "frontend": "Code", "backend": "Code",
  "fullstack": "Code", "full stack": "Code", "react": "Code", "node": "Code",
  "data": "BarChart", "analyst": "BarChart", "business": "BarChart",
  "designer": "Palette", "design": "Palette", "ux": "Palette", "ui": "Palette",
  "marketing": "TrendingUp", "growth": "TrendingUp", "digital": "TrendingUp",
  "finance": "DollarSign", "financial": "DollarSign", "accountant": "DollarSign",
  "cloud": "Cloud", "devops": "Cloud", "aws": "Cloud", "azure": "Cloud",
  "machine learning": "Cpu", "ml": "Cpu", "ai": "Cpu", "engineer": "Cpu",
  "product": "Target", "manager": "Target", "pm": "Target",
  "security": "Shield", "cyber": "Shield",
  "mobile": "Smartphone", "android": "Smartphone", "ios": "Smartphone",
  "hr": "Users", "human": "Users", "recruiter": "Users",
  "zap": "Zap",
};

function pickRoleIcon(title = "") {
  const t = title.toLowerCase();
  for (const [kw, icon] of Object.entries(ROLES_ICON_MAP)) {
    if (t.includes(kw)) return icon;
  }
  return "Briefcase";
}

const COMPANY_COLORS_MAP = {
  Google: "#4285F4", Amazon: "#FF9900", Microsoft: "#00A4EF",
  Meta: "#1877F2", Apple: "#555555", Netflix: "#E50914",
  Flipkart: "#2874F0", Uber: "#000000",
};

const INTERVIEW_COMPANY = (() => {
  const seen = new Set();
  return INTERVIEW_DATA
    .filter(d => { if (seen.has(d.company)) return false; seen.add(d.company); return true; })
    .map(d => ({
      l:     d.company.slice(0, 2).toUpperCase(),
      bg:    COMPANY_COLORS_MAP[d.company] || "#263012",
      name:  d.company,
      count: `${INTERVIEW_DATA.filter(x => x.company === d.company).length} Questions`,
    }));
})();

const INTERVIEW_ROLE = (() => {
  const seen = new Set();
  return INTERVIEW_DATA
    .filter(d => { if (seen.has(d.role)) return false; seen.add(d.role); return true; })
    .map(r => ({
      l:    r.role.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase(),
      bg:   "#263012",
      name: r.role,
      count: `${INTERVIEW_DATA.filter(x => x.role === r.role).length} Questions`,
    }));
})();

const SALARY_OPTIONS = [
  { value: "0–3 LPA", label: "0 – 3 LPA", desc: "Entry level", icon: "💰" },
  { value: "3–6 LPA", label: "3 – 6 LPA", desc: "Junior", icon: "💰" },
  { value: "6–10 LPA", label: "6 – 10 LPA", desc: "Mid-level", icon: "💸" },
  { value: "10–20 LPA", label: "10 – 20 LPA", desc: "Senior", icon: "💸" },
  { value: "20+ LPA", label: "20+ LPA", desc: "Lead / Expert", icon: "🤑" },
];

const EXPERIENCE_OPTIONS = [
  { value: "Fresher", label: "Fresher", desc: "0 years", icon: "🌱" },
  { value: "1–3 Yrs", label: "1–3 Years", desc: "Junior", icon: "🚀" },
  { value: "3–5 Yrs", label: "3–5 Years", desc: "Mid-level", icon: "⚡" },
  { value: "5–10 Yrs", label: "5–10 Years", desc: "Senior", icon: "💎" },
  { value: "10+ Yrs", label: "10+ Years", desc: "Expert", icon: "🏆" },
];

const JOB_TYPE_OPTIONS = [
  { value: "Full-time", label: "Full-Time", desc: "Permanent role", icon: "🏢" },
  { value: "Part-time", label: "Part-Time", desc: "Flexible hours", icon: "🕐" },
  { value: "Remote", label: "Remote", desc: "Work from home", icon: "🌐" },
  { value: "Hybrid", label: "Hybrid", desc: "Mix of both", icon: "🔄" },
  { value: "Internship", label: "Internship", desc: "Learning role", icon: "🎓" },
  { value: "Freelance", label: "Freelance", desc: "Project-based", icon: "🛠️" },
  { value: "Contract", label: "Contract", desc: "Fixed-term", icon: "📋" },
];

const STEPS = [
  { emoji: "Search", color: "#263012", colorLight: "#F4F7ED", colorText: "#3F4F1A", label: "Step 01", badge: "Search", title: "Search your dream role", desc: "Type any job title, skill, or keyword. Smart filters for location, salary, experience and job type help you zero in fast.", features: ["Job title, skill or keyword search","Location & city filters","Salary range matching","Experience level filter"], cta: "Start Searching", path: "/employee/jobs" },
  { emoji: "FileText", color: "#5E7D21", colorLight: "#F1F5E8", colorText: "#3A4A18", label: "Step 02", badge: "Resume", title: "Build a stellar resume", desc: "Use our AI Resume Builder to craft an ATS-optimised resume in minutes. Get an instant score and fix gaps before you apply.", features: ["12+ ATS-friendly templates","AI-powered bullet writing","Instant ATS score check","One-click PDF export"], cta: "Build Resume", path: "/employee/resume-builder" },
  { emoji: "Target", color: "#556B1F", colorLight: "#EEF3E3", colorText: "#2F3A18", label: "Step 03", badge: "Apply", title: "Apply with one click", desc: "Hit Apply Now on any listing. Your saved profile and resume auto-fill the form — the whole thing takes under 30 seconds.", features: ["Auto-fill from saved profile","One-click application","Track submission status","Get recruiter alerts"], cta: "Browse Jobs", path: "/employee/jobs" },
  { emoji: "Trophy", color: "#4F621B", colorLight: "#E9F0DA", colorText: "#2A3415", label: "Step 04", badge: "Rewards", title: "Track & earn rewards", desc: "Monitor your application in your dashboard. Earn XP for every action and redeem points for courses or cash.", features: ["Real-time application tracking","XP for every action","Redeem for courses & cash","Weekly leaderboard ranking"], cta: "View Dashboard", path: "/employee/profile" },
];

const N = STEPS.length;
const POSITIONS = [
  { tx: 0, ty: 0, tz: 0, rx: 0, ry: 0, scale: 1, z: 10, op: 1, shadow: "0 28px 64px rgba(0,0,0,.22), 0 6px 16px rgba(0,0,0,.12)" },
  { tx: 36, ty: 18, tz: -120, rx: 5, ry: -10, scale: 0.92, z: 7, op: 0.78, shadow: "0 10px 28px rgba(0,0,0,.10)" },
  { tx: 62, ty: 34, tz: -230, rx: 9, ry: -18, scale: 0.84, z: 4, op: 0.48, shadow: "0 6px 16px rgba(0,0,0,.07)" },
  { tx: 82, ty: 48, tz: -330, rx: 12, ry: -24, scale: 0.77, z: 1, op: 0.20, shadow: "0 3px 8px rgba(0,0,0,.05)" },
];

/* ═══════════════════════════════
   HOOKS & UTILITIES
═══════════════════════════════ */
function mapCompanyItem(company = {}) {
  const name = company.company_name || company.name || company.company || "Company";
  const initials = (name || "C").split(" ").map(p => p.trim()[0]).filter(Boolean).slice(0, 2).join("").toUpperCase() || "C";
  return {
    id: company.id, name,
    logo: company.company_logo || null,
    initials, industry: company.industry || "Hiring",
    location: company.location || company.city || "India",
    activeJobs: Number(company.active_jobs || 0),
    totalJobs: Number(company.total_jobs || company.active_jobs || 0),
    applicants: Number(company.total_applicants || 0),
    companySize: company.company_size || company.size || "Not shared",
    about: company.about || company.hiring_bio || ""
  };
}

const aosDir = (i) => (i % 2 === 0 ? "fade-right" : "fade-left");
const aosDelay = (i, step = 80) => i * step;

function fuzzyMatch(query, list, limit = 6) {
  if (!query || query.trim().length < 1) return [];
  const q = query.toLowerCase().trim();
  const scored = list.map(item => {
    const s = item.toLowerCase();
    if (s.startsWith(q)) return { item, score: 3 };
    if (s.includes(q)) return { item, score: 2 };
    let m = 0;
    for (const ch of q) if (s.includes(ch)) m++;
    if (m / q.length > 0.7) return { item, score: 1 };
    return { item, score: 0 };
  }).filter(x => x.score > 0).sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map(x => x.item);
}

function simulateDbSearch(query, dataset, type = "text") {
  return new Promise(resolve => {
    setTimeout(() => {
      if (!query || query.trim().length < 1) { resolve([]); return; }
      const q = query.toLowerCase().trim();
      const items = type === "city"
        ? dataset.map(c => ({ name: c.name, emoji: c.emoji }))
        : dataset.map(s => ({ name: s }));
      const scored = items.map(item => {
        const s = item.name.toLowerCase();
        if (s.startsWith(q)) return { item, score: 4 };
        if (s.includes(` ${q}`)) return { item, score: 3 };
        if (s.includes(q)) return { item, score: 2 };
        let m = 0;
        for (const ch of q) if (s.includes(ch)) m++;
        if (m / q.length > 0.65) return { item, score: 1 };
        return { item, score: 0 };
      }).filter(x => x.score > 0).sort((a, b) => b.score - a.score);
      resolve(scored.slice(0, Math.min(8, scored.length)).map(x => x.item));
    }, 120 + Math.random() * 180);
  });
}

function useMagnetic(strength = 0.35) {
  const ref = useRef(null);
  const move = useCallback(e => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * strength}px,${(e.clientY - r.top - r.height / 2) * strength}px) scale(1.04)`;
  }, [strength]);
  const leave = useCallback(() => { if (ref.current) ref.current.style.transform = ""; }, []);
  return { ref, onMouseMove: move, onMouseLeave: leave };
}

function ScorePopup({ x, y, text, onDone }) {
  useEffect(() => { const t = setTimeout(onDone, 1200); return () => clearTimeout(t); }, [onDone]);
  return <div className="th-score-popup" style={{ left: x, top: y }}>{text}</div>;
}

ScorePopup.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  onDone: PropTypes.func.isRequired,
};

function ParticleBurst({ x, y, onDone }) {
  const ps = Array.from({ length: 12 }, (_, i) => ({
    angle: (i / 12) * 360,
    color: ["#12160a","#7c3aed","#10b981","#ec4899","#06b6d4"][i % 5]
  }));
  useEffect(() => { const t = setTimeout(onDone, 800); return () => clearTimeout(t); }, [onDone]);
  return (
    <div className="th-particle-wrap" style={{ left: x, top: y }}>
      {ps.map((p, i) => (
        <div key={`particle-${i}`} className="th-particle" style={{ "--angle": `${p.angle}deg`, background: p.color, animationDelay: `${i * 20}ms` }} />
      ))}
    </div>
  );
}

ParticleBurst.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  onDone: PropTypes.func.isRequired,
};

function ShimmerBtn({ children, className = "th-btn", onClick, style = {} }) {
  const [bursts, setBursts] = useState([]);
  const mag = useMagnetic(0.3);
  const click = e => {
    const r = e.currentTarget.getBoundingClientRect();
    const id = Date.now();
    setBursts(b => [...b, { id, x: e.clientX - r.left, y: e.clientY - r.top }]);
    if (onClick) onClick(e);
  };
  return (
    <button {...mag} className={`${className} th-shimmer-btn`} style={style} onClick={click}>
      {children}
      <span className="th-shimmer-sweep" />
      {bursts.map(b => (
        <ParticleBurst key={b.id} x={b.x} y={b.y} onDone={() => setBursts(p => p.filter(x => x.id !== b.id))} />
      ))}
    </button>
  );
}

ShimmerBtn.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

function BlinkChip({ slotIndex, poolOffset }) {
  const [current, setCurrent] = useState((slotIndex + poolOffset) % ALL_COMPANIES_POOL.length);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const init = setTimeout(() => setVisible(true), slotIndex * 280 + 350);
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrent(prev => {
          let n;
          do { n = Math.floor(Math.random() * ALL_COMPANIES_POOL.length); } while (n === prev);
          return n;
        });
        setVisible(true);
      }, 500);
    }, 3200 + slotIndex * 600 + Math.random() * 1400);
    return () => { clearTimeout(init); clearInterval(cycle); };
  }, [slotIndex]);
  const co = ALL_COMPANIES_POOL[current];
  return (
    <div className={`th-chip ${visible ? "th-chip--show" : "th-chip--hide"}`}>
      <div className="th-chip__logo" style={{ background: co.bg }}>{co.letter}</div>
      <div><div className="th-chip__name">{co.name}</div><div className="th-chip__jobs">{co.jobs}</div></div>
      <span className="th-chip__live" />
    </div>
  );
}

BlinkChip.propTypes = {
  slotIndex: PropTypes.number.isRequired,
  poolOffset: PropTypes.number.isRequired,
};

function AnimCounter({ target, suffix }) {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !started.current) {
        started.current = true;
        const steps = 60;
        let step = 0;
        const t = setInterval(() => {
          step++;
          setVal(Math.round(target * (1 - Math.pow(1 - step / steps, 3))));
          if (step >= steps) clearInterval(t);
        }, 1800 / steps);
      }
    }, { threshold: 0.5 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [target]);
  return <span ref={ref}>{val}{suffix}</span>;
}

AnimCounter.propTypes = {
  target: PropTypes.number.isRequired,
  suffix: PropTypes.string.isRequired,
};

function CursorTooltip({ tip }) {
  return (
    <div
      className={`th-cursor-tooltip-box${tip.visible ? " th-cursor-tooltip-box--visible" : ""}`}
      style={{ left: tip.x + 16, top: tip.y }}
    >
      <span className="th-cursor-tooltip-icon"><Icons.Zap size={12} color="#263012" /></span>
      {tip.text}
    </div>
  );
}

CursorTooltip.propTypes = {
  tip: PropTypes.shape({
    visible: PropTypes.bool,
    x: PropTypes.number,
    y: PropTypes.number,
    text: PropTypes.string,
  }).isRequired,
};

function AutocompleteInput({ value, onChange, placeholder, suggestions, onSelect }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const filtered = value.length >= 1
    ? fuzzyMatch(value, suggestions.map(s => (typeof s === "string" ? s : s.name)))
    : [];
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  return (
    <div ref={ref} style={{ flex: 1, position: "relative", minWidth: 0, display: "flex", flexDirection: "column", width: "100%" }}>
      <input
        style={{ border: "none", outline: "none", background: "transparent", fontSize: "1.4rem", fontWeight: 700, color: "#0d1117", fontFamily: "inherit", minWidth: 0, width: "100%", padding: 0, lineHeight: 1.2 }}
        type="text" placeholder={placeholder} value={value}
        onChange={e => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => { if (filtered.length > 0 || value.length >= 1) setOpen(true); }}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        onKeyDown={e => { if (e.key === "Enter") setOpen(false); }}
        autoComplete="off"
      />
      {open && filtered.length > 0 && (
        <div className="th-ac-dropdown" style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 9999 }}>
          {filtered.map((s, i) => (
            <div key={`ac-${i}`} className="th-ac-item" style={{ animationDelay: `${i * 30}ms` }} onMouseDown={() => { onSelect(s); setOpen(false); }}>
              <span className="th-ac-item-icon"><Icons.Search size={14} color="#9ca3af" /></span>
              <span className="th-ac-item-text">{s}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

AutocompleteInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  suggestions: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
};

function LocationInput({ value, onChange, onSelect }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const filtered = value.length >= 1
    ? fuzzyMatch(value, POPULAR_CITIES.map(c => c.name)).map(n => POPULAR_CITIES.find(c => c.name === n) || { name: n, emoji: "📍" })
    : POPULAR_CITIES;
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  return (
    <div ref={ref} style={{ flex: 1, position: "relative", minWidth: 0, display: "flex", flexDirection: "column", width: "100%" }}>
      <input
        style={{ border: "none", outline: "none", background: "transparent", fontSize: "1.4rem", fontWeight: 700, color: "#0d1117", fontFamily: "inherit", minWidth: 0, width: "100%", padding: 0, lineHeight: 1.2 }}
        type="text" placeholder="Enter city" value={value}
        onChange={e => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        autoComplete="off"
      />
      {open && filtered.length > 0 && (
        <div className="th-ac-dropdown" style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 9999 }}>
          {!value && <div className="th-ac-section-label">Popular Cities</div>}
          {filtered.slice(0, 8).map((city, i) => (
            <div key={`city-${i}`} className="th-ac-item" style={{ animationDelay: `${i * 25}ms` }} onMouseDown={() => { onSelect(city.name); setOpen(false); }}>
              <span className="th-ac-city-emoji">{city.emoji}</span>
              <span className="th-ac-item-text">{city.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

LocationInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

function CustomSelect({ value, onChange, placeholder, icon, options }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selected = options.find(o => o.value === value);
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  return (
    <div ref={ref} className="th-autocomplete-wrap th-custom-select-wrap">
      <div
        className={`th-sb__field th-custom-select-trigger${open ? " th-custom-select-trigger--open" : ""}`}
        onClick={() => setOpen(o => !o)}
        onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setOpen(o => !o); } }}
        role="button"
        tabIndex={0}
        style={{ gap: 9, padding: "9px 14px", cursor: "pointer" }}
      >
        <span>{icon}</span>
        <span className={`th-custom-select-value${!selected ? " th-custom-select-placeholder" : ""}`}>
          {selected ? selected.label : placeholder}
        </span>
        {value && (
          <button className="th-ac-clear" onClick={e => { e.stopPropagation(); onChange(""); setOpen(false); }}>✕</button>
        )}
        <span className={`th-custom-select-arrow${open ? " th-custom-select-arrow--up" : ""}`}>›</span>
      </div>
      {open && (
        <div className="th-ac-dropdown th-custom-select-dropdown">
          <div className="th-ac-section-label" style={{ paddingBottom: 6 }}>{icon} {placeholder}</div>
          {options.map((opt, i) => (
            <div
              key={`opt-${i}`}
              className={`th-ac-item th-custom-select-item${value === opt.value ? " th-custom-select-item--active" : ""}`}
              style={{ animationDelay: `${i * 30}ms` }}
              onMouseDown={() => { onChange(opt.value); setOpen(false); }}
            >
              <span className="th-ac-city-emoji">{opt.icon}</span>
              <div style={{ flex: 1 }}>
                <span className="th-ac-item-text">{opt.label}</span>
                {opt.desc && <span className="th-custom-select-desc">{opt.desc}</span>}
              </div>
              {value === opt.value && <span className="th-custom-select-check">✓</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

CustomSelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  options: PropTypes.array.isRequired,
};

function SalaryPositionInput({ value, onChange, onSelect }) {
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);
  const debRef = useRef(null);
  useEffect(() => {
    if (debRef.current) clearTimeout(debRef.current);
    if (!value || value.trim().length < 1) { setSuggestions([]); setOpen(false); return; }
    debRef.current = setTimeout(async () => {
      setLoading(true);
      const r = await simulateDbSearch(value, SALARY_DB_POSITIONS, "text");
      setSuggestions(r);
      setOpen(r.length > 0);
      setLoading(false);
    }, 220);
    return () => clearTimeout(debRef.current);
  }, [value]);
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  return (
    <div ref={ref} style={{ flex: 1, position: "relative" }}>
      <div className="th-salary__field">
        <Icons.Briefcase size={16} color="#9ca3af" />
        <input className="th-salary__input" type="text" placeholder="Position (e.g. Software Engineer)" value={value}
          onChange={e => onChange(e.target.value)}
          onFocus={() => { if (suggestions.length > 0) setOpen(true); }}
          onBlur={() => setTimeout(() => setOpen(false), 160)}
          autoComplete="off"
        />
        {loading && <span className="th-salary-loading">⏳</span>}
        {value && !loading && <button className="th-ac-clear" onClick={() => { onChange(""); setSuggestions([]); setOpen(false); }}>✕</button>}
      </div>
      {open && suggestions.length > 0 && (
        <div className="th-ac-dropdown" style={{ top: "100%", left: 0 }}>
          <div className="th-ac-section-label"><Icons.Briefcase size={12} color="#9ca3af" /> {suggestions.length} match{suggestions.length !== 1 ? "es" : ""}</div>
          {suggestions.map((s, i) => (
            <div key={`sp-${i}`} className="th-ac-item" style={{ animationDelay: `${i * 28}ms` }} onMouseDown={() => { onSelect(s.name); setOpen(false); setSuggestions([]); }}>
              <span className="th-ac-item-icon"><Icons.Briefcase size={14} color="#9ca3af" /></span>
              <span className="th-ac-item-text">{s.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

SalaryPositionInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

function SalaryLocationInput({ value, onChange, onSelect }) {
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const ref = useRef(null);
  const debRef = useRef(null);
  useEffect(() => {
    if (debRef.current) clearTimeout(debRef.current);
    if (!value || value.trim().length < 1) { setSuggestions([]); setOpen(false); return; }
    debRef.current = setTimeout(async () => {
      setLoading(true);
      const r = await simulateDbSearch(value, SALARY_DB_CITIES, "city");
      setSuggestions(r);
      setOpen(r.length > 0);
      setLoading(false);
    }, 200);
    return () => clearTimeout(debRef.current);
  }, [value]);
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  return (
    <div ref={ref} style={{ flex: 1, position: "relative" }}>
      <div className="th-salary__field">
        <Icons.MapPin size={16} color="#9ca3af" />
        <input className="th-salary__input" type="text" placeholder="Location (optional)" value={value}
          onChange={e => onChange(e.target.value)}
          onFocus={() => { if (suggestions.length > 0) setOpen(true); }}
          onBlur={() => setTimeout(() => setOpen(false), 160)}
          autoComplete="off"
        />
        {loading && <span className="th-salary-loading">⏳</span>}
        {value && !loading && <button className="th-ac-clear" onClick={() => { onChange(""); setSuggestions([]); setOpen(false); }}>✕</button>}
      </div>
      {open && suggestions.length > 0 && (
        <div className="th-ac-dropdown" style={{ top: "100%", left: 0 }}>
          <div className="th-ac-section-label">🌍 {suggestions.length} match{suggestions.length !== 1 ? "es" : ""}</div>
          {suggestions.map((s, i) => (
            <div key={`sl-${i}`} className="th-ac-item" style={{ animationDelay: `${i * 25}ms` }} onMouseDown={() => { onSelect(s.name); setOpen(false); setSuggestions([]); }}>
              <span className="th-ac-city-emoji">{s.emoji || "📍"}</span>
              <span className="th-ac-item-text">{s.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

SalaryLocationInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
};

function CourseSearchBar({ onSearch }) {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const ref    = useRef(null);
  const debRef = useRef(null);

  useEffect(() => {
    if (debRef.current) clearTimeout(debRef.current);
    if (!query || query.trim().length < 1) { setSuggestions([]); setOpen(false); return; }
    debRef.current = setTimeout(async () => {
      setLoading(true);
      const r = await simulateDbSearch(query, COURSE_SEARCH_DB, "text");
      setSuggestions(r);
      setOpen(r.length > 0);
      setLoading(false);
    }, 200);
    return () => clearTimeout(debRef.current);
  }, [query]);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const doSearch = useCallback((q) => {
    const term = (q ?? query).trim();
    if (!term) return;
    setOpen(false);
    setSuggestions([]);
    if (onSearch) onSearch(term);
  }, [query, onSearch]);

  const handleSuggestionPick = (name) => {
    setQuery(name);
    doSearch(name);
  };

  return (
    <div ref={ref} className="th-course-search-wrap" data-aos="fade-up" data-aos-delay="60">
      <div className="th-course-searchbar">
        <div className="th-course-search-field">
          <span className="th-course-search-icon">
            <Icons.Search size={16} color="#9ca3af" />
          </span>
          <input
            className="th-course-search-input"
            type="text"
            placeholder="Search courses, skills, technologies..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onFocus={() => { if (suggestions.length > 0) setOpen(true); }}
            onBlur={() => setTimeout(() => setOpen(false), 160)}
            onKeyDown={(e) => {
              if (e.key === "Enter") { e.preventDefault(); doSearch(); }
              if (e.key === "Escape") setOpen(false);
            }}
            autoComplete="off"
          />
          {loading && <span className="th-salary-loading" style={{ marginRight: 8 }}>⏳</span>}
          {query && !loading && (
            <button className="th-ac-clear" onClick={() => { setQuery(""); setSuggestions([]); setOpen(false); }}>✕</button>
          )}
        </div>

        <button className="th-course-search-btn th-shimmer-btn" onClick={() => doSearch()}>
          Search Courses
          <span className="th-shimmer-sweep" />
        </button>
      </div>

      {open && suggestions.length > 0 && (
        <div className="th-ac-dropdown th-course-search-dropdown">
          <div className="th-ac-section-label">
            <Icons.FileText size={12} color="#9ca3af" /> Suggestions
          </div>
          {suggestions.map((s, i) => (
            <div
              key={`csug-${i}`}
              className="th-ac-item"
              style={{ animationDelay: `${i * 28}ms` }}
              onMouseDown={(e) => { e.preventDefault(); handleSuggestionPick(s.name); }}
            >
              <span className="th-ac-item-icon"><Icons.FileText size={14} color="#9ca3af" /></span>
              <span className="th-ac-item-text">{s.name}</span>
            </div>
          ))}
        </div>
      )}

      <div className="th-course-search-tags">
        {["React", "Python", "Machine Learning", "UI/UX", "AWS", "DevOps"].map((tag, i) => (
          <button key={`ctag-${i}`} className="th-course-search-tag" onClick={() => { setQuery(tag); doSearch(tag); }}>
            {tag}
          </button>
        ))}
      </div>
    </div>
  );
}

CourseSearchBar.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

function ExperienceDropdown({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selected = EXPERIENCE_OPTIONS.find(o => o.value === value);
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  return (
    <div
      ref={ref}
      className="mmt-filter-field"
      onClick={() => setOpen(o => !o)}
      onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setOpen(o => !o); } }}
      role="button"
      tabIndex={0}
    >
      <div className="mmt-filter-field__label"><Icons.Award size={10} color="#9ca3af" /> Experience Level <span className="mmt-chevron">▼</span></div>
      <div className={`mmt-filter-field__val${!selected ? " mmt-filter-field__val--placeholder" : ""}`}>
        {selected ? `${selected.icon} ${selected.label}` : "Any Experience"}
      </div>
      <div className="mmt-filter-field__sub">{selected ? selected.desc : "Fresher to Expert"}</div>
      {value && (
        <button className="mmt-filter-field__clear" onMouseDown={e => { e.stopPropagation(); onChange(""); }}>✕</button>
      )}
      {open && (
        <div className="th-ac-dropdown" style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, minWidth: 220, zIndex: 9999 }}>
          <div className="th-ac-section-label"><Icons.Award size={12} color="#9ca3af" /> Experience Level</div>
          {EXPERIENCE_OPTIONS.map((opt, i) => (
            <div
              key={`exp-${i}`}
              className={`th-ac-item th-custom-select-item${value === opt.value ? " th-custom-select-item--active" : ""}`}
              style={{ animationDelay: `${i * 30}ms` }}
              onMouseDown={() => { onChange(opt.value); setOpen(false); }}
            >
              <span className="th-ac-city-emoji">{opt.icon}</span>
              <div style={{ flex: 1 }}>
                <span className="th-ac-item-text">{opt.label}</span>
                <span className="th-custom-select-desc">{opt.desc}</span>
              </div>
              {value === opt.value && <span className="th-custom-select-check">✓</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

ExperienceDropdown.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

function SalaryDropdown({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selected = SALARY_OPTIONS.find(o => o.value === value);
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  return (
    <div
      ref={ref}
      className="mmt-filter-field"
      onClick={() => setOpen(o => !o)}
      onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setOpen(o => !o); } }}
      role="button"
      tabIndex={0}
    >
      <div className="mmt-filter-field__label"><Icons.DollarSign size={10} color="#9ca3af" /> Salary Range <span className="mmt-chevron">▼</span></div>
      <div className={`mmt-filter-field__val${!selected ? " mmt-filter-field__val--placeholder" : ""}`}>
        {selected ? `${selected.icon} ${selected.label}` : "Any Salary"}
      </div>
      <div className="mmt-filter-field__sub">{selected ? selected.desc : "No filter"}</div>
      {value && (
        <button className="mmt-filter-field__clear" onMouseDown={e => { e.stopPropagation(); onChange(""); }}>✕</button>
      )}
      {open && (
        <div className="th-ac-dropdown" style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, minWidth: 220, zIndex: 9999 }}>
          <div className="th-ac-section-label"><Icons.DollarSign size={12} color="#9ca3af" /> Salary Range</div>
          {SALARY_OPTIONS.map((opt, i) => (
            <div
              key={`sal-${i}`}
              className={`th-ac-item th-custom-select-item${value === opt.value ? " th-custom-select-item--active" : ""}`}
              style={{ animationDelay: `${i * 30}ms` }}
              onMouseDown={() => { onChange(opt.value); setOpen(false); }}
            >
              <span className="th-ac-city-emoji">{opt.icon}</span>
              <div style={{ flex: 1 }}>
                <span className="th-ac-item-text">{opt.label}</span>
                <span className="th-custom-select-desc">{opt.desc}</span>
              </div>
              {value === opt.value && <span className="th-custom-select-check">✓</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

SalaryDropdown.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

/* ── Resume & ATS Showcase ── */
function ResumeAtsSection({ navigate }) {
  const [atsScore, setAtsScore] = useState(0);
  const [scoreVisible, setScoreVisible] = useState(false);
  const secRef = useRef(null);
  useEffect(() => {
    const el = secRef.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !scoreVisible) {
        setScoreVisible(true);
        let cur = 0;
        const target = 87;
        const t = setInterval(() => {
          cur += 2;
          setAtsScore(Math.min(cur, target));
          if (cur >= target) clearInterval(t);
        }, 22);
      }
    }, { threshold: 0.3 });
    io.observe(el);
    return () => io.disconnect();
  }, [scoreVisible]);

  return (
    <section ref={secRef} className="ras-section head-th-slide">
      <div className="th-container">
        <div className="th-sh" data-aos="fade-up">
          <h2 className="th-sh-title">Your Career, <span className="th-grad">Supercharged</span></h2>
          <p className="th-sh-sub">Two powerful tools — one to build, one to check. Both free.</p>
        </div>
        <div className="ras-grid">
          <div className="ras-card ras-card--resume" data-aos="fade-right" data-aos-delay="80">
            <div className="ras-ribbon">Free Tool</div>
            <div className="ras-card-top">
              <div className="ras-icon-wrap"><div className="ras-icon"><Icons.FileText size={28} color="#263012" animated /></div><div className="ras-icon-glow" /></div>
              <h3 className="ras-card-title">Resume Builder</h3>
            </div>
            <p className="ras-card-desc">12+ professional templates with drag-and-drop editing. Export to PDF in one click.</p>
            <div className="ras-divider" />
            <ul className="ras-feature-list">
              {["ATS-friendly templates","One-click PDF export","Auto-fill from LinkedIn"].map((f, i) => (
                <li key={`rf-${i}`} className="ras-feat-item"><span className="ras-feat-tick"><Icons.CheckCircle size={10} color="#3a5018" /></span>{f}</li>
              ))}
            </ul>
            <button className="ras-btn ras-btn--blue" onClick={() => navigate("/employee/resume-builder")}>Build My Resume <Icons.ArrowRight size={14} color="#fff" /></button>
          </div>

          <div className="ras-card ras-card--ai ras-card--featured" data-aos="zoom-in" data-aos-delay="100">
            <div className="ras-ai-glow-ring" />
            <div className="ras-particles">{Array.from({ length: 10 }).map((_, i) => <div key={`rp-${i}`} className="ras-particle" style={{ "--pi": i }} />)}</div>
            <div className="ras-card-top">
              <div className="ras-icon-wrap ras-icon-wrap--lg"><div className="ras-icon ras-icon--lg"><Icons.Cpu size={36} color="#c8d890" /></div><div className="ras-icon-glow ras-icon-glow--ai" /></div>
              <h3 className="ras-card-title ras-card-title--white">AI Resume <span className="ras-ai-gradient-text">Builder</span></h3>
            </div>
            <p className="ras-card-desc ras-card-desc--light">Paste a job description — our AI tailors every bullet and scores 90%+ on every ATS system automatically.</p>
            <div className="ras-divider ras-divider--dark" />
            <ul className="ras-feature-list">
              {["Writes bullets in 10 seconds","Job-description targeting","Live ATS score while editing","Unlimited rewrites, always free"].map((f, i) => (
                <li key={`af-${i}`} className="ras-feat-item ras-feat-item--ai"><span className="ras-feat-tick ras-feat-tick--ai"><Icons.CheckCircle size={10} color="#c8d890" /></span>{f}</li>
              ))}
            </ul>
            <button className="ras-btn ras-btn--ai ras-btn--wide" onClick={() => navigate("/employee/resume-builder?mode=ai")}>Try AI Builder Free ✨</button>
          </div>

          <div className="ras-card ras-card--ats" data-aos="fade-left" data-aos-delay="80">
            <div className="ras-ribbon ras-ribbon--ats">Instant · Free</div>
            <div className="ras-card-top">
              <div className="ras-icon-wrap"><div className="ras-icon"><Icons.Shield size={28} color="#16a34a" /></div><div className="ras-icon-glow ras-icon-glow--ats" /></div>
              <h3 className="ras-card-title">ATS Score Checker</h3>
            </div>
            <div className="ras-ats-row">
              <div className="ras-ats-ring-wrap">
                <svg viewBox="0 0 120 120" className="ras-ats-svg">
                  <circle cx="60" cy="60" r="48" fill="none" stroke="rgba(16,185,129,0.12)" strokeWidth="9" />
                  <circle cx="60" cy="60" r="48" fill="none" stroke="#16a34a" strokeWidth="9" strokeLinecap="round"
                    strokeDasharray={`${2 * Math.PI * 48}`}
                    strokeDashoffset={`${2 * Math.PI * 48 * (1 - atsScore / 100)}`}
                    transform="rotate(-90 60 60)"
                    style={{ transition: "stroke-dashoffset 0.05s linear" }}
                  />
                  <text x="60" y="54" textAnchor="middle" fill="#15803d" fontSize="24" fontWeight="800">{atsScore}</text>
                  <text x="60" y="70" textAnchor="middle" fill="#6b7280" fontSize="10">Score</text>
                </svg>
              </div>
              <div className="ras-ats-info"><div className="ras-ats-label">ATS Result</div><div className="ras-ats-sub">Scans 50+ filters with keyword & formatting checks.</div></div>
            </div>
            <div className="ras-divider" />
            <ul className="ras-feature-list">
              {["Keyword gap analysis","Formatting error detection","vs. top applicants"].map((f, i) => (
                <li key={`atf-${i}`} className="ras-feat-item"><span className="ras-feat-tick ras-feat-tick--green"><Icons.CheckCircle size={10} color="#15803d" /></span>{f}</li>
              ))}
            </ul>
            <button className="ras-btn ras-btn--green" onClick={() => navigate("/employee/ats-score-checker")}>Check My ATS Score <Icons.ArrowRight size={14} color="#fff" /></button>
          </div>
        </div>
      </div>
    </section>
  );
}

ResumeAtsSection.propTypes = {
  navigate: PropTypes.func.isRequired,
};

/* ── How To Apply ── */
function playClick() {
  try {
const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.connect(g);
    g.connect(ctx.destination);
    o.type = "sine";
    o.frequency.setValueAtTime(900, ctx.currentTime);
    o.frequency.exponentialRampToValueAtTime(400, ctx.currentTime + 0.13);
    g.gain.setValueAtTime(0.15, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.2);
    o.start();
    o.stop(ctx.currentTime + 0.22);
  } catch (e) {
    console.warn("Audio playback failed:", e);
  }
}

function HowToApplySection({ navigate }) {
  const [active, setActive] = useState(0);
  const [throwing, setThrowing] = useState(null);
  const [animating, setAnimating] = useState(false);
  const activeRef = useRef(active);
  const animatingRef = useRef(animating);
  const autoRef = useRef(null);

  useEffect(() => { activeRef.current = active; }, [active]);
  useEffect(() => { animatingRef.current = animating; }, [animating]);

  const advance = useCallback((silent = false) => {
    if (animatingRef.current) return;
    animatingRef.current = true;
    setAnimating(true);
    if (!silent) playClick();
    const current = activeRef.current;
    setThrowing(current);
    setTimeout(() => {
      setThrowing(null);
      setActive(a => {
        const next = (a + 1) % N;
        activeRef.current = next;
        return next;
      });
      setTimeout(() => {
        animatingRef.current = false;
        setAnimating(false);
      }, 650);
    }, 280);
  }, []);

  const resetAuto = useCallback(() => {
    clearInterval(autoRef.current);
    autoRef.current = setInterval(() => advance(true), 2500);
  }, [advance]);

  useEffect(() => {
    resetAuto();
    return () => clearInterval(autoRef.current);
  }, [resetAuto]);

  const goTo = useCallback((idx) => {
    if (idx === activeRef.current || animatingRef.current) return;
    animatingRef.current = true;
    setAnimating(true);
    playClick();
    setActive(idx);
    activeRef.current = idx;
    setTimeout(() => { animatingRef.current = false; setAnimating(false); }, 680);
    resetAuto();
  }, [resetAuto]);

  const prev = useCallback(() => {
    if (animatingRef.current) return;
    animatingRef.current = true;
    setAnimating(true);
    playClick();
    setActive(a => {
      const next = (a + N - 1) % N;
      activeRef.current = next;
      return next;
    });
    setTimeout(() => { animatingRef.current = false; setAnimating(false); }, 680);
    resetAuto();
  }, [resetAuto]);

  const getRel = (i, a) => ((i - a) % N + N) % N;

  const StepIcon = ({ iconName, size = 48, color = "#263012" }) => {
    const IconComp = Icons[iconName];
    return IconComp ? <IconComp size={size} color={color} animated /> : null;
  };

  StepIcon.propTypes = {
    iconName: PropTypes.string.isRequired,
    size: PropTypes.number,
    color: PropTypes.string,
  };

  return (
    <section style={{
      padding: "56px 0 56px", background: "#ffffff",
      overflow: "hidden", fontFamily: "'IBM Plex Sans', system-ui, sans-serif"
    }}>
      <div style={{ maxWidth: 960, margin: "0 auto", padding: "0 1.25rem" }}>
        <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
          <h2 className="th-sh-title" style={{ marginBottom: ".5rem" }}>
            Land your job in <span className="th-grad">4 easy steps</span>
          </h2>
          <p style={{ fontSize: 15, color: "#888", margin: 0 }}>
            Tap the front card to send it to the back of the stack.
          </p>
        </div>

        <div style={{
          perspective: 1300, perspectiveOrigin: "50% 38%",
          display: "flex", justifyContent: "center",
          alignItems: "center", minHeight: 560, position: "relative"
        }}>
          {STEPS.map((s, i) => {
            const r = getRel(i, active);
            const p = POSITIONS[Math.min(r, N - 1)];
            const isThrown = throwing === i;

            const transform = isThrown
              ? "translate(-70px, -130px) translateZ(90px) rotateX(-20deg) rotateY(30deg) scale(0.70)"
              : `translate(${p.tx}px,${p.ty}px) translateZ(${p.tz}px) rotateX(${p.rx}deg) rotateY(${p.ry}deg) scale(${p.scale})`;

            const transition = isThrown
              ? "transform .50s cubic-bezier(.55,.05,.7,.95), opacity .32s ease"
              : "transform .62s cubic-bezier(.34,1.15,.64,1), opacity .55s ease";

            return (
              <div
                key={`step-${i}`}
                onClick={() => { if (r === 0 && !animating) { advance(false); resetAuto(); } }}
                style={{
                  position: "absolute", width: "min(90vw, 860px)",
                  minHeight: 480, height: "auto", borderRadius: 22,
                  transformStyle: "preserve-3d", zIndex: p.z,
                  opacity: isThrown ? 0 : p.op, boxShadow: p.shadow,
                  cursor: r === 0 ? "pointer" : "default",
                  transform, transition, willChange: "transform, opacity"
                }}
              >
                <div style={{
                  width: "100%", height: "100%", borderRadius: 22, overflow: "hidden",
                  display: "flex", flexDirection: "column", background: "#ffffff",
                  border: "1.5px solid rgba(128,128,128,.11)",
                  fontFamily: "'IBM Plex Sans', system-ui, sans-serif"
                }}>
                  <div style={{ height: 8, background: s.color, flexShrink: 0 }} />
                  <div style={{ padding: "1.8rem 2rem 1.4rem", flex: 1, display: "flex", flexDirection: "column" }}>
                    <div style={{
                      display: "inline-flex", alignItems: "center", fontSize: 12, fontWeight: 700,
                      letterSpacing: ".1em", textTransform: "uppercase", borderRadius: 999,
                      padding: "5px 16px", marginBottom: "1rem",
                      background: s.colorLight, color: s.colorText,
                      border: `1px solid ${s.color}50`, width: "fit-content"
                    }}>
                      {s.label} · {s.badge}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: ".7rem" }}>
                      <div style={{ flexShrink: 0, filter: "drop-shadow(0 2px 6px rgba(0,0,0,.12))" }}>
                        <StepIcon iconName={s.emoji} size={44} color={s.color} />
                      </div>
                      <h3 style={{ fontSize: "clamp(1.45rem, 2.2vw, 1.85rem)", fontWeight: 600, color: "#0f0f0f", margin: 0, lineHeight: 1.28 }}>
                        {s.title}
                      </h3>
                    </div>
                    <p style={{ fontSize: 16, color: "#5a5a5a", lineHeight: 1.75, margin: "0 0 1.2rem", flex: 1 }}>
                      {s.desc}
                    </p>
                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                      {s.features.map((f, j) => (
                        <div key={`feat-${j}`} style={{
                          display: "flex", alignItems: "center", gap: 10, fontSize: 14,
                          color: "#263012", padding: "9px 14px", borderRadius: 10,
                          background: "#f4f5f2", fontWeight: 500
                        }}>
                          <div style={{ width: 8, height: 8, borderRadius: "50%", background: s.color, flexShrink: 0 }} />
                          {f}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div style={{
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    padding: "1rem 2rem", borderTop: "0.5px solid #e4e4e2", background: "#f8f9f6"
                  }}>
                    <button
                      onClick={e => { e.stopPropagation(); navigate(s.path); }}
                      style={{
                        border: "none", borderRadius: 999, padding: "11px 28px",
                        fontSize: 13, fontWeight: 700, letterSpacing: ".07em",
                        textTransform: "uppercase", color: "#fff", background: s.color,
                        cursor: "pointer", transition: "opacity .15s, transform .15s"
                      }}
                      onMouseEnter={e => { e.currentTarget.style.opacity = ".85"; e.currentTarget.style.transform = "scale(1.04)"; }}
                      onMouseLeave={e => { e.currentTarget.style.opacity = "1"; e.currentTarget.style.transform = ""; }}
                    >
                      {s.cta} →
                    </button>
                    <div style={{
                      fontSize: 13, fontWeight: 600, color: s.colorText,
                      background: s.colorLight, border: `1px solid ${s.color}40`,
                      borderRadius: 999, padding: "6px 16px"
                    }}>
                      {s.label}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "1.2rem", marginTop: "1.8rem" }}>
          <button
            onClick={() => { prev(); resetAuto(); }}
            style={{
              width: 42, height: 42, borderRadius: "50%", border: "1.5px solid #d8d8d6",
              background: "#fff", fontSize: 22, cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: "#333", transition: "background .15s"
            }}
            onMouseEnter={e => e.currentTarget.style.background = "#f0f0ee"}
            onMouseLeave={e => e.currentTarget.style.background = "#fff"}
          >
            ‹
          </button>
          <div style={{ display: "flex", gap: 7, alignItems: "center" }}>
            {STEPS.map((s, i) => (
              <div
                key={`dot-${i}`}
                onClick={() => { goTo(i); resetAuto(); }}
                onKeyDown={e => { if (e.key === "Enter") { goTo(i); resetAuto(); } }}
                role="button"
                tabIndex={0}
                style={{
                  height: 8, borderRadius: 4, cursor: "pointer",
                  width: i === active ? 28 : 8,
                  background: i === active ? STEPS[active].color : "#d4d4d2",
                  transition: "all .35s cubic-bezier(.34,1.56,.64,1)"
                }}
              />
            ))}
          </div>
          <button
            onClick={() => { advance(false); resetAuto(); }}
            style={{
              width: 42, height: 42, borderRadius: "50%", border: "1.5px solid #d8d8d6",
              background: "#fff", fontSize: 22, cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: "#333", transition: "background .15s"
            }}
            onMouseEnter={e => e.currentTarget.style.background = "#f0f0ee"}
            onMouseLeave={e => e.currentTarget.style.background = "#fff"}
          >
            ›
          </button>
        </div>
      </div>
    </section>
  );
}

HowToApplySection.propTypes = {
  navigate: PropTypes.func.isRequired,
};

/* ── Earn Rewards sub-components ── */
function ErConfetti({ onDone }) {
  const pieces = Array.from({ length: 24 }, (_, i) => ({
    angle: (i / 24) * 360,
    color: ["#6366f1","#f59e0b","#10b981","#ec4899","#0ea5e9","#1d240e"][i % 6],
    size: 4 + Math.random() * 6,
    dist: 48 + Math.random() * 52,
    shape: Math.random() > 0.5 ? "circle" : "square"
  }));
  useEffect(() => { const t = setTimeout(onDone, 1200); return () => clearTimeout(t); }, [onDone]);
  return (
    <div style={{ position: "absolute", inset: 0, pointerEvents: "none", zIndex: 30, overflow: "hidden" }}>
      {pieces.map((p, i) => (
        <div key={`conf-${i}`} style={{
          position: "absolute", top: "50%", left: "50%",
          width: p.size, height: p.size, background: p.color,
          borderRadius: p.shape === "circle" ? "50%" : "2px",
          transform: "translate(-50%,-50%)",
          animation: `er-confetti-new 1.1s cubic-bezier(.2,.8,.4,1) ${i * 22}ms forwards`,
          "--a": `${p.angle}deg`, "--d": `${p.dist}px`
        }} />
      ))}
    </div>
  );
}

ErConfetti.propTypes = { onDone: PropTypes.func.isRequired };

function RewardIcon({ iconName, size = 22, color = "#6366f1" }) {
  const IconComp = Icons[iconName];
  return IconComp ? <IconComp size={size} color={color} /> : null;
}

RewardIcon.propTypes = {
  iconName: PropTypes.string.isRequired,
  size: PropTypes.number,
  color: PropTypes.string,
};

function ErRewardHCard({ card, index, visible, isLoggedIn, navigate }) {
  const [barW, setBarW] = useState(0);
  const safePct = clampPct(card?.pct);
  const requiredPts = toNum(card?.pts, 0);
  const claimedText = isLoggedIn
    ? (card?.progressText || `${safePct}% of your reward goal`)
    : `${safePct}% claimed this month`;
  const cardPath = card?.path || "/employee/profile";

  const onCardClick = useCallback(() => {
    if (isLoggedIn) { navigate(cardPath); return; }
    navigate("/employee/login");
  }, [cardPath, isLoggedIn, navigate]);

  useEffect(() => {
    if (!visible) { setBarW(0); return; }
    const t = setTimeout(() => setBarW(safePct), 300 + index * 120);
    return () => clearTimeout(t);
  }, [visible, safePct, index]);

  return (
    <div
      className="er-reward-hcard"
      data-aos={aosDir(index)}
      data-aos-delay={aosDelay(index, 70)}
      style={{ "--rc-color": card.color }}
      onClick={onCardClick}
      onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onCardClick(); } }}
      role="button"
      tabIndex={0}
    >
      <div className="er-reward-hcard__icon-wrap" style={{ background: card.bg }}>
        <RewardIcon iconName={card.icon} size={22} color={card.color} />
      </div>
      <div className="er-reward-hcard__body">
        <div className="er-reward-hcard__top">
          <span className="er-reward-hcard__label">{card.label}</span>
          <span className="er-reward-hcard__pts" style={{ color: card.color }}>{requiredPts.toLocaleString()} pts</span>
        </div>
        <div className="er-reward-hcard__bar-track">
          <div className="er-reward-hcard__bar" style={{ width: `${barW}%`, background: card.color }} />
        </div>
        <div className="er-reward-hcard__claimed">{claimedText}</div>
      </div>
      {isLoggedIn ? (
        <div className="er-reward-hcard__cta" style={{ color: card.color }}>Open →</div>
      ) : (
        <button
          type="button"
          className="er-reward-login-cta"
          onClick={(e) => { e.stopPropagation(); navigate("/employee/login"); }}
          style={{ "--er-login-color": card.color }}
        >
          <Icons.Lock size={11} color="#fff" /> Login
        </button>
      )}
    </div>
  );
}

ErRewardHCard.propTypes = {
  card: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  visible: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  navigate: PropTypes.func.isRequired,
};

function ErLbRow({ row, index }) {
  return (
    <div className={`er-new-lb-row${row.isMe ? " er-new-lb-row--me" : ""}`} data-aos={aosDir(index)} data-aos-delay={aosDelay(index, 45)}>
      <span className="er-new-lb-medal">{row.medal}</span>
      <div className="er-new-lb-ava" style={{ background: row.bg }}><span>{row.ava}</span></div>
      <span className="er-new-lb-name">{row.name}{row.isMe && <span className="er-new-lb-you-tag">YOU</span>}</span>
      <div className="er-new-lb-bar-wrap"><div className="er-new-lb-bar" style={{ width: `${(row.pts / 4820) * 100}%` }} /></div>
      <span className="er-new-lb-pts">{row.pts.toLocaleString()}</span>
    </div>
  );
}

ErLbRow.propTypes = {
  row: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

function useUserRewards(isLoggedIn, authUser) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reloadTick, setReloadTick] = useState(0);
  const refetch = useCallback(() => { setReloadTick(v => v + 1); }, []);

  useEffect(() => {
    if (!isLoggedIn) { setData(null); setLoading(false); setError(null); return; }
    const token = authUser?.token || readAuthToken();
    if (!token) { setData(null); setLoading(false); setError("No active session"); return; }
    let active = true;
    setLoading(true);
    setError(null);

    async function fetchRewards() {
      try {
        const headers = { Authorization: `Bearer ${token}` };
        const [profileRes, applicationsRes] = await Promise.all([
          fetch(`${API_BASE}/candidate/profile`, { headers }),
          fetch(`${API_BASE}/applications/mine`, { headers }).catch(() => null)
        ]);
        if (!profileRes.ok) throw new Error("Unable to load profile");
        const [profile, applicationsPayload] = await Promise.all([
          profileRes.json().catch(() => ({})),
          applicationsRes?.ok ? applicationsRes.json().catch(() => ({})) : Promise.resolve({})
        ]);
        if (!active) return;
        const profileData = (profile && typeof profile === "object") ? profile : {};
        const applications = Array.isArray(applicationsPayload?.data) ? applicationsPayload.data
          : (Array.isArray(applicationsPayload) ? applicationsPayload : []);
        const candidateId = toNum(profileData?.id, 0);
        let ratings = [];
        if (candidateId > 0) {
          const ratingsRes = await fetch(`${API_BASE}/candidate/${candidateId}/ratings`, { headers }).catch(() => null);
          if (ratingsRes?.ok) {
            const ratingsPayload = await ratingsRes.json().catch(() => ({}));
            ratings = Array.isArray(ratingsPayload?.ratings) ? ratingsPayload.ratings : [];
          }
        }
        const userName = [profileData.first_name, profileData.last_name].filter(Boolean).join(" ").trim()
          || profileData.full_name || profileData.name || authUser?.name || "User";
        const metrics = computeRewardMetrics(profileData, applications, ratings);
        const userPts = computeProfileScore(profileData, applications, ratings);
        const { leaderboard, rank } = buildLeaderboardWithUser(userName, userPts);
        const rewardCards = buildRewardCardsFromScore(userPts, metrics);
        const activity = buildProfileActivity(profileData, applications, [], metrics);
        const streakCount = Math.min(7,
          toNum(metrics?.referralCount, 0) + toNum(metrics?.offerVerifiedCount, 0)
          + Math.min(3, toNum(metrics?.positiveRatingsCount, 0)) + toNum(metrics?.profileCompleteCount, 0)
        );
        const streakDone = ER_STREAK.map((_, i) => i < streakCount);
        setData({ userName, userPts, userRank: rank, streakCount, streakDone, leaderboard, activity, rewardCards, rewardMetrics: metrics, source: "live-profile" });
      } catch (err) {
        if (active) { setData(null); setError(err?.message || "Unable to load rewards"); }
      } finally {
        if (active) setLoading(false);
      }
    }

    fetchRewards();
    const poll = setInterval(fetchRewards, 30_000);
    return () => { active = false; clearInterval(poll); };
  }, [isLoggedIn, authUser?.id, authUser?.token, authUser?.name, reloadTick]);

  return { data, loading, error, refetch };
}

function SignupSlide({ navigate }) {
  const [pct, setPct] = useState(0);
  const [dragging, setDragging] = useState(false);
  const [unlocked, setUnlocked] = useState(false);
  const [confetti, setConfetti] = useState(false);
  const [glow, setGlow] = useState(false);
  const trackRef = useRef(null);
  const startX = useRef(0);
  const frameRef = useRef(null);
  const TW = 64;

  useEffect(() => {
    if (unlocked) return;
    const t = setInterval(() => setGlow(g => !g), 1800);
    return () => clearInterval(t);
  }, [unlocked]);

  const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

  const getW = () => {
    if (!trackRef.current) return 320;
    return trackRef.current.getBoundingClientRect().width || 320;
  };

  const moveTo = useCallback((cx) => {
    const maxX = getW() - TW;
    if (maxX <= 0) return;
    const p = clamp(((cx - startX.current) / maxX) * 100, 0, 100);
    setPct(p);
    if (p >= 97 && !unlocked) {
      setPct(100);
      setUnlocked(true);
      setConfetti(true);
      setTimeout(() => navigate("/employee/signup"), 1600);
    }
  }, [unlocked, navigate]);

  const onDown = useCallback((e) => {
    if (unlocked) return;
    if (!trackRef.current) return;
    e.currentTarget.setPointerCapture(e.pointerId);
    startX.current = e.clientX - (pct / 100) * (getW() - TW);
    setDragging(true);
  }, [unlocked, pct]);

  const onMove = useCallback((e) => {
    if (!dragging) return;
    if (frameRef.current) cancelAnimationFrame(frameRef.current);
    frameRef.current = requestAnimationFrame(() => moveTo(e.clientX));
  }, [dragging, moveTo]);

  const onUp = useCallback(() => {
    if (!dragging) return;
    setDragging(false);
    if (pct < 97 && !unlocked) {
      let cur = pct;
      const spring = () => {
        cur *= 0.72;
        setPct(cur);
        if (cur > 0.5) requestAnimationFrame(spring);
        else setPct(0);
      };
      requestAnimationFrame(spring);
    }
  }, [dragging, pct, unlocked]);

  useEffect(() => {
   window.addEventListener("pointermove", onMove);
window.addEventListener("pointerup", onUp);
return () => {
  window.removeEventListener("pointermove", onMove);
  window.removeEventListener("pointerup", onUp);
      if (frameRef.current) cancelAnimationFrame(frameRef.current);
    };
  }, [onMove, onUp]);

  const thumbX = `calc(${pct}% * (1 - ${TW}px / 100%))`;
  const fillW = `calc(${pct}% * (1 - ${TW}px / 100%) + ${TW / 2}px)`;

  return (
    <div className="er-signup-slide">
      <div className="er-signup-slide__head">
        <div className="er-signup-slide__icon-row"><div className="er-signup-slide__icon-wrap"><Icons.DollarSign size={28} color="#263012" /></div></div>
        <h3 className="er-signup-slide__title">Earn cash rewards with verified actions</h3>
        <p className="er-signup-slide__sub">Complete real actions to earn points: referral signup (100), verified offer letter (200), positive rating (+5 each), and profile 100% completion (100).</p>
      </div>
      <div className="er-signup-slide__perks">
        {[
          { icon: "Users", label: "Referral signup complete: +100", color: "#6366f1" },
          { icon: "FileText", label: "Interview + verified offer letter: +200", color: "#10b981" },
          { icon: "Star", label: "Per positive rating: +5", color: "#f59e0b" },
          { icon: "CheckCircle", label: "Profile 100% complete: +100", color: "#14b8a6" },
          { icon: "Clock", label: "Offer-letter verification: within 48 hours", color: "#263012" },
        ].map((p, i) => {
          const PIcon = Icons[p.icon];
          return (
            <div key={`perk-${i}`} className="er-signup-perk">
              <span className="er-signup-perk__icon" style={{ background: `${p.color}18` }}>
                {PIcon && <PIcon size={16} color={p.color} />}
              </span>
              <span className="er-signup-perk__label">{p.label}</span>
            </div>
          );
        })}
      </div>
      <div className={`er-gs${unlocked ? " er-gs--on" : ""}${dragging ? " er-gs--drag" : ""}`}>
        <div className="er-gs-track" ref={trackRef}>
          <div className="er-gs-fill" style={{ width: fillW }} />
          <div className="er-gs-shimmer" style={{ opacity: dragging ? 0.6 : 0.3 }} />
          {unlocked
            ? <div className="er-gs-label er-gs-label--done">You&apos;re In! Redirecting…</div>
            : <div className="er-gs-label"><span className="er-gs-label-text" style={{ opacity: Math.max(0, 1 - pct / 40) }}>Slide to Join Free</span></div>
          }
          <div className={`er-gs-thumb${glow && !dragging && !unlocked ? " er-gs-thumb--glow" : ""}`} style={{ left: thumbX }} onPointerDown={onDown}>
            <span className="er-gs-thumb-icon">
              {unlocked ? <Icons.CheckCircle size={18} color="#16a34a" /> : <Icons.ArrowRight size={16} color="#263012" />}
            </span>
            {!unlocked && <span className="er-gs-thumb-ripple" />}
          </div>
          {confetti && <ErConfetti onDone={() => setConfetti(false)} />}
        </div>
      </div>
      <div className="er-signup-slide__divider"><span>or</span></div>
      <button className="er-signup-slide__login-btn" onClick={() => navigate("/employee/login")}>
        Already have an account? <strong>Log In</strong>
      </button>
    </div>
  );
}

SignupSlide.propTypes = { navigate: PropTypes.func.isRequired };

function UserRewardsPanel({ data: rawData, navigate, flash, pts }) {
  const data = rawData || buildFallbackRewardsData();
  const safeUserName = data.userName || "User";
  const safeRewardCards = Array.isArray(data.rewardCards) ? data.rewardCards : [];
  const safeLeaderboard = Array.isArray(data.leaderboard) ? data.leaderboard : [];
  const safeActivity = Array.isArray(data.activity) ? data.activity : [];
  const safeStreakDone = Array.isArray(data.streakDone) ? data.streakDone : ER_STREAK.map(() => false);

  return (
    <>
      <div className="er-user-hero" data-aos="fade-up" data-aos-delay="60">
        <div className="er-user-hero__left">
          <div className="er-user-hero__avatar">{safeUserName.split(" ").map(p => p[0]).join("").slice(0, 2).toUpperCase()}</div>
          <div>
            <div className="er-user-hero__name">Hi, {safeUserName.split(" ")[0]} 👋</div>
            <div className="er-user-hero__rank">Rank #{data.userRank} · {data.streakCount}-day streak 🔥</div>
          </div>
        </div>
        <div className="er-user-hero__right">
          <div className="er-user-hero__pts-label">Your XP Balance</div>
          <div className="er-user-hero__pts">{flash && <span className="er-new-flash">{flash}</span>}{pts.toLocaleString()}</div>
        </div>
      </div>

      <div className="er-new-rewards-block" data-aos="fade-up" data-aos-delay="80">
        <div className="er-new-rewards-header">
          <div className="er-new-rewards-title"><Icons.Gift size={16} color="#263012" style={{ display:"inline", verticalAlign:"middle", marginRight:6 }} /> Cash Reward Progress</div>
          <div className="er-new-rewards-sub">Only verified plan actions are credited</div>
        </div>
        <div className="er-new-rewards-list">
          {safeRewardCards.map((card, i) => (
            <ErRewardHCard key={`rc-${i}`} card={card} index={i} visible isLoggedIn navigate={navigate} />
          ))}
        </div>
        <div className="er-rewards-cta-row">
          <button className="er-rewards-cta-btn er-rewards-cta-btn--outline" onClick={() => navigate("/employee/rewards")}>
            <Icons.Trophy size={16} color="#263012" /> Check Rewards
          </button>
          <button className="er-rewards-cta-btn er-rewards-cta-btn--fill" onClick={() => navigate("/employee/dashboard")}>
            <Icons.Zap size={16} color="#fff" /> Go to Dashboard
          </button>
        </div>
      </div>

      <div className="er-new-bottom">
        <div className="er-new-bottom-left" data-aos="fade-right" data-aos-delay="100">
          <div className="er-new-panel">
            <div className="er-new-panel-head">
              <span className="er-new-panel-title"><Icons.Trophy size={14} color="#263012" style={{ display:"inline", verticalAlign:"middle", marginRight:6 }} />Weekly Leaderboard</span>
              <span className="er-new-pts-live">{flash && <span className="er-new-flash">{flash}</span>}{pts.toLocaleString()} pts</span>
            </div>
            {safeLeaderboard.map((row, i) => <ErLbRow key={`lb-${i}`} row={row} index={i} />)}
            <div className="er-new-streak">
              <span style={{ display:"flex", alignItems:"center" }}><Icons.Zap size={16} color="#f59e0b" /></span>
              <span className="er-new-streak-label">{data.streakCount}-day streak</span>
              <div className="er-new-streak-days">
                {["M","T","W","T","F","S","S"].map((d, i) => (
                  <div key={`sd-${i}`} className={`er-new-sd${safeStreakDone[i] ? " er-new-sd--on" : ""}`}>
                    {safeStreakDone[i] ? <Icons.CheckCircle size={12} color="#fff" /> : d}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="er-new-bottom-right" data-aos="fade-left" data-aos-delay="140">
          <div className="er-new-panel er-new-activity-panel">
            <div className="er-new-panel-head">
              <span className="er-new-panel-title"><Icons.Zap size={14} color="#263012" style={{ display:"inline", verticalAlign:"middle", marginRight:6 }} />Recent Activity</span>
            </div>
            <div className="er-new-act-list">
              {safeActivity.length === 0 && (
                <div className="er-new-act-row" style={{ justifyContent: "center", color: "#6b7280", fontSize: "0.85rem" }}>No reward activity yet.</div>
              )}
              {safeActivity.map((a, i) => {
                const ActIcon = Icons[a.icon];
                return (
                  <div key={`act-${i}`} className="er-new-act-row" data-aos={aosDir(i)} data-aos-delay={aosDelay(i, 60)}>
                    <div className="er-new-act-icon" style={{ background:`${a.accent}18`, color:a.accent }}>
                      {ActIcon && <ActIcon size={18} color={a.accent} />}
                    </div>
                    <div className="er-new-act-body">
                      <span className="er-new-act-lbl">{a.label}</span>
                      <span className="er-new-act-time">{a.time}</span>
                    </div>
                    <span className="er-new-act-pts" style={{ color:a.accent }}>{a.pts}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

UserRewardsPanel.propTypes = {
  data: PropTypes.object,
  navigate: PropTypes.func.isRequired,
  flash: PropTypes.string,
  pts: PropTypes.number.isRequired,
};

function ErSkeleton() {
  return (
    <div className="er-skeleton">
      {[180, 120, 80].map((h, i) => (
        <div key={`erskel-${i}`} className="er-skeleton__block" style={{ height: h, animationDelay: `${i * 0.15}s` }} />
      ))}
    </div>
  );
}

function EarnRewardsSection({ navigate, isLoggedIn, authLoading, authUser }) {
  const secRef = useRef(null);
  const prevPts = useRef(null);
  const [flash, setFlash] = useState(null);
  const [pts, setPts] = useState(2450);
  const { data, loading, error, refetch } = useUserRewards(isLoggedIn, authUser);

  useEffect(() => { if (typeof data?.userPts === "number") setPts(data.userPts); }, [data?.userPts]);
  useEffect(() => {
    if (!isLoggedIn || !data) return;
    if (prevPts.current === null) { prevPts.current = data.userPts; return; }
    if (data.userPts > prevPts.current) {
      const diff = data.userPts - prevPts.current;
      setFlash(`+${diff}`);
      setTimeout(() => setFlash(null), 900);
    }
    prevPts.current = data.userPts;
  }, [data?.userPts, isLoggedIn]);

  return (
    <section ref={secRef} className="er-new-section head-th-slide">
      <div className="er-new-bg-blob1" /><div className="er-new-bg-blob2" />
      <div className="er-new-inner">
        <div className="er-new-header" data-aos="fade-up" data-aos-delay="0">
          <h2 className="er-new-title">Earn while you <span className="er-new-title-accent">Job Hunt.</span></h2>
        </div>
        {authLoading ? <ErSkeleton /> : isLoggedIn ? (
          loading ? <ErSkeleton /> : error ? (
            <div className="er-new-panel" style={{ maxWidth: 740, margin: "24px auto 0", textAlign: "center", padding: "24px 20px" }}>
              <div style={{ fontWeight: 700, color: "#111827", marginBottom: 6 }}>Could not load your rewards activity</div>
              <div style={{ color: "#6b7280", marginBottom: 14, fontSize: "0.92rem" }}>Please refresh or retry.</div>
              <button className="er-rewards-cta-btn er-rewards-cta-btn--fill" onClick={refetch}>Retry</button>
            </div>
          ) : (
            data ? <UserRewardsPanel data={data} navigate={navigate} flash={flash} pts={pts} /> : <ErSkeleton />
          )
        ) : (
          <div className="er-logged-out-layout">
            <div className="er-logged-out-signup" data-aos="fade-up" data-aos-delay="120">
              <SignupSlide navigate={navigate} />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

EarnRewardsSection.propTypes = {
  navigate: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  authLoading: PropTypes.bool.isRequired,
  authUser: PropTypes.object,
};

function ToolsCard({ navigate, onLaunchCalculatorMenu, onShowTip, onMoveTip, onHideTip }) {
  const [activeId, setActiveId] = useState(null);

  const handleToolClick = (tool) => {
    if (tool.isDropdown) { if (onLaunchCalculatorMenu) onLaunchCalculatorMenu(); return; }
    setActiveId(tool.id);
    setTimeout(() => { navigate(tool.path); setActiveId(null); }, 220);
  };

  return (
    <div className="tc-wrap">
      {TOOLS.map((tool, index) => {
        const ToolIcon = Icons[tool.icon];
        return (
          <div
            key={tool.id}
            className={`thc-card${activeId === tool.id ? " thc-card--active" : ""}`}
            style={{ "--tc-color": "#263012" }}
            data-aos={aosDir(index)}
            data-aos-delay={aosDelay(index, 70)}
            onClick={() => handleToolClick(tool)}
            onKeyDown={e => { if (e.key === "Enter") handleToolClick(tool); }}
            onMouseEnter={e => { if (onShowTip) onShowTip(tool.strip || tool.desc, e); }}
            onMouseMove={e => { if (onMoveTip) onMoveTip(tool.strip || tool.desc, e); }}
            onMouseLeave={() => { if (onHideTip) onHideTip(); }}
            role="button"
            tabIndex={0}
          >
            <div className="tc-icon-ring">{ToolIcon ? <ToolIcon size={36} color="#263012" animated /> : null}</div>
            <div className="tc-labels">
              <span className="tc-label-main">{tool.label}</span>
              <span className="tc-label-sub">{tool.sublabel}</span>
            </div>
            {tool.isDropdown && <span className="tc-chevron">›</span>}
            <span className="tc-active-bar" />
          </div>
        );
      })}
    </div>
  );
}

ToolsCard.propTypes = {
  navigate: PropTypes.func.isRequired,
  onLaunchCalculatorMenu: PropTypes.func,
  onShowTip: PropTypes.func,
  onMoveTip: PropTypes.func,
  onHideTip: PropTypes.func,
};

/* ═══════════════════════════════
   MAIN PAGE
═══════════════════════════════ */
export default function HeadJob() {
  const { user, loading: authLoading } = useAuth();

  const [cursorTip, setCursorTip] = useState({ text: "", x: 0, y: 0, visible: false });
  const showTip = (text, e) => setCursorTip({ text, x: e.clientX + 14, y: e.clientY, visible: true });
  const moveTip = (text, e) => setCursorTip(t => ({ ...t, text, x: e.clientX + 14, y: e.clientY }));
  const hideTip = () => setCursorTip(t => ({ ...t, visible: false }));

  const { roles: dynamicRoles, loading: rolesLoading } = usePopularRoles();
  const { sponsors: dynamicSponsors, loading: sponsorsLoading } = useSponsors();

  const [position, setPosition] = useState("");
  const [salaryLoc, setSalaryLoc] = useState("");
  const [iqTab, setIqTab] = useState("company");
  const [scores, setScores] = useState([]);
  const [topCompanies, setTopCompanies] = useState([]);
  const [companiesLoading, setCompaniesLoading] = useState(true);
  const isLoggedIn = Boolean(user?.token || readAuthToken());

  const router = useNavigate();
  const navigate = path => router(path);

  const hjhHeroRef = useRef(null);
  const [hjhLoaded, setHjhLoaded] = useState(false);

  useEffect(() => { const t = setTimeout(() => setHjhLoaded(true), 120); return () => clearTimeout(t); }, []);

  const HERO_JOB_CARDS = [
    { role: "Senior UI/UX Designer", company: "Google", location: "Remote", type: "Full-time", salary: "₹28–35 LPA", logo: "G" },
    { role: "Frontend Developer", company: "Stripe", location: "Bangalore", type: "Full-time", salary: "₹22–30 LPA", logo: "S" },
    { role: "Product Manager", company: "Notion", location: "Hybrid", type: "Contract", salary: "₹30–40 LPA", logo: "N" },
    { role: "ML Engineer", company: "OpenAI", location: "Remote", type: "Full-time", salary: "₹45–60 LPA", logo: "O" },
  ];

  useEffect(() => {
    const id = setInterval(() => {}, 2800);
    return () => clearInterval(id);
  }, [HERO_JOB_CARDS.length]);

  useEffect(() => {
    let active = true;
    async function loadTopCompanies() {
      try {
        const res = await fetch(`${API_BASE}/companies?limit=6&page=1&sort=jobs`);
        const data = await res.json();
        const rows = Array.isArray(data.data) ? data.data.map(mapCompanyItem) : [];
        if (active) setTopCompanies(rows);
      } catch {
        if (active) setTopCompanies([
          { id: "infosys", name: "Infosys", initials: "I", industry: "IT Services", location: "Bengaluru", activeJobs: 2400, totalJobs: 2600, applicants: 18000, companySize: "200k+", about: "Hiring across engineering, consulting, and operations." },
          { id: "tcs", name: "TCS", initials: "T", industry: "IT Services", location: "Mumbai", activeJobs: 3200, totalJobs: 3500, applicants: 24000, companySize: "500k+", about: "One of the largest recruiters on the platform." },
          { id: "wipro", name: "Wipro", initials: "W", industry: "IT Services", location: "Bengaluru", activeJobs: 1100, totalJobs: 1300, applicants: 9700, companySize: "200k+", about: "Recruiting for tech, support, and digital roles." },
          { id: "amazon", name: "Amazon", initials: "A", industry: "E-Commerce / Tech", location: "Hyderabad", activeJobs: 640, totalJobs: 720, applicants: 9200, companySize: "50k-200k", about: "High-growth openings across engineering and operations." },
          { id: "flipkart", name: "Flipkart", initials: "F", industry: "E-Commerce", location: "Bengaluru", activeJobs: 390, totalJobs: 420, applicants: 6400, companySize: "20k-50k", about: "Product, engineering, and analytics roles." },
          { id: "google", name: "Google India", initials: "G", industry: "Technology", location: "Gurugram", activeJobs: 220, totalJobs: 240, applicants: 3800, companySize: "10k-50k", about: "Focused on product, cloud, and AI roles." },
        ]);
      } finally {
        if (active) setCompaniesLoading(false);
      }
    }
    loadTopCompanies();
    return () => { active = false; };
  }, []);

  const spawnScore = (e, text) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const id = Date.now() + Math.random();
    setScores(s => [...s, { id, x: e.clientX - rect.left, y: e.clientY - rect.top, text }]);
  };

  const RoleIcon = ({ iconName, size = 22, color = "#263012" }) => {
    const IconComp = Icons[iconName];
    return IconComp ? <IconComp size={size} color={color} /> : null;
  };

  return (
    <div className="th-root head-th-page">

      {/* ═══ HERO ═══ */}
      <section className="hjh-hero" ref={hjhHeroRef}>
        <div className="hjh-hero__glow" />
        <div className="hjh-hero__dots" />
        <div className={`hjh-hero__center ${hjhLoaded ? "in" : ""}`}>
          <h1 className="hjh-hero__heading" style={{ color: "#263012" }}>
            Find Work That<br />
            <em className="hjh-hero__heading-em">Fits Your</em> Ambition.
          </h1>
          <div className="hjh-hero__actions">
            <button className="hjh-hero__btn hjh-hero__btn--primary" onClick={() => navigate("/employee/jobs")}>
              Browse Jobs
              <svg viewBox="0 0 20 20" fill="none"><path d="M4 10h12M11 5l5 5-5 5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </button>
            <button className="hjh-hero__btn hjh-hero__btn--outline" onClick={() => {
              try {
                const token = localStorage.getItem("token");
                const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
                if (token && storedUser?.role === "recruiter") navigate("/employer/recruiter-dashboard");
                else navigate("/employer/signup");
              } catch { navigate("/employer/signup"); }
            }}>Post a Job</button>
          </div>
        </div>
      </section>

      {/* ═══ TOP COMPANIES ═══ */}
      <section className="th-section th-section--soft head-th-slide" style={{ backgroundColor: "rgb(255, 255, 255)" }}>
        <div className="th-container">
          <div className="th-co-grid">
            {companiesLoading
              ? Array.from({ length: 6 }).map((_, i) => (
                  <div key={`coskel-${i}`} className="th-co-card" data-aos={aosDir(i)} data-aos-delay={aosDelay(i, 60)}>
                    <div className="cc-skel" style={{ width: "100%", height: 180, borderRadius: 20 }} />
                  </div>
                ))
              : topCompanies.map((co, i) => (
                  <div key={co.id || `co-${i}`} className="th-co-card" data-aos={aosDir(i)} data-aos-delay={aosDelay(i, 80)} style={{ "--co-color": "#12160a" }}
                    onMouseEnter={e => showTip(`See all open roles at ${co.name}`, e)}
                    onMouseMove={e => moveTip(`See all open roles at ${co.name}`, e)}
                    onMouseLeave={hideTip}
                  >
                    <div className="th-co-card__header">
                      <div className="th-co-logo" style={{ background: "linear-gradient(135deg,#12160a,#263012)", boxShadow: "0 8px 24px rgba(18,22,10,.28)", overflow: "hidden" }}>
                        {co.logo ? <img src={co.logo} alt={co.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : co.initials}
                      </div>
                      <div className="th-co-card__meta">
                        <div className="th-co-name">{co.name}</div>
                        <div className="th-co-rank" style={{ color: "#263012", background: "#f2f5ea" }}>Hiring in {co.industry}</div>
                      </div>
                    </div>
                    <p className="th-co-desc">{co.about || "Actively hiring on Talent Hive."}</p>
                    <div className="th-co-tags">
                      <span className="th-co-tag" style={{ color: "#263012", background: "#f2f5ea", borderColor: "#c8d4a0" }}>{co.location}</span>
                      <span className="th-co-tag" style={{ color: "#263012", background: "#f2f5ea", borderColor: "#c8d4a0" }}>{co.companySize}</span>
                    </div>
                    <div className="th-co-card__stats">
                      <div className="th-co-stat"><span className="th-co-stat__val" style={{ color: "#4a5e20" }}>{co.activeJobs}</span><span className="th-co-stat__lbl">Open roles</span></div>
                      <div className="th-co-stat"><span className="th-co-stat__lbl">{co.totalJobs} jobs</span></div>
                      <div className="th-co-stat"><span className="th-co-stat__lbl">{co.applicants} applicants</span></div>
                    </div>
                    <button className="th-co-btn" style={{ "--btn-color": "#12160a" }} onClick={() => navigate(`/employee/jobs?company=${encodeURIComponent(co.name)}`)}>
                      <span>View Jobs</span>
                    </button>
                  </div>
                ))
            }
          </div>
        </div>
      </section>

      <HowToApplySection navigate={navigate} />

      {/* ═══ SALARY GUIDE ═══ */}
      <section className="th-section th-section--white head-th-slide">
        <div className="th-container">
          <div className="th-sh" data-aos="fade-up" data-aos-delay="0">
            <h2 className="th-sh-title">Know Your Market <span className="th-grad">Salary</span></h2>
            <p className="th-sh-sub">Real-time salary insights tailored to your role and city.</p>
          </div>
          <p className="th-salary__hint" data-aos="fade-up" data-aos-delay="60">Search by position, location, or both</p>
          <div data-aos="fade-up" data-aos-delay="100">
            <div className="th-salary__bar">
              <SalaryPositionInput value={position} onChange={setPosition} onSelect={setPosition} />
              <div className="th-salary__sep" />
              <SalaryLocationInput value={salaryLoc} onChange={setSalaryLoc} onSelect={setSalaryLoc} />
            </div>
          </div>
          <div className="th-salary__chips" data-aos="fade-up" data-aos-delay="140">
            {SALARY_CHIPS.map((c, i) => (
              <button key={`sc-${i}`} className="th-salary__chip" onClick={() => { setPosition(c); navigate(`/employee/salary-guide?role=${encodeURIComponent(c)}`); }}>
                <span className="th-salary__chip-dot" />{c}
              </button>
            ))}
          </div>
        </div>
      </section>

      <ResumeAtsSection navigate={navigate} />

      {/* ═══ COMPANY BALLS ═══ */}
      <section className="th-section th-section--white head-th-slide">
        <CompanyBalls navigate={navigate} />
        <div style={{ textAlign: "center" }} data-aos="fade-up" data-aos-delay="160">
          <ShimmerBtn onClick={() => navigate("/employee/companies")} style={{ fontSize: ".95rem", padding: "14px 36px" }}>
            Explore All Companies →
          </ShimmerBtn>
        </div>
      </section>

      {/* ═══ COURSES ═══ */}
      <TopCoursesSection navigate={navigate} />

      {/* ═══ MARQUEE ═══ */}
      <div className="th-sponsored head-th-slide">
        <div className="th-sponsored__header">
          <h2 className="th-sh-title" data-aos="fade-up" data-aos-delay="60">Sponsored <span className="th-grad">Hiring Partners</span></h2>
          <p className="th-sh-sub" data-aos="fade-up" data-aos-delay="100" style={{ marginTop: 8 }}>Partnered with India&apos;s leading employers seeking top talent.</p>
        </div>
        {!sponsorsLoading && [false, true].map((rev, ri) => (
          <div key={`mq-${ri}`} className="th-mq-wrap" style={ri ? { marginTop: 14 } : {}}>
            <div className={`th-mq ${rev ? "th-mq--r" : "th-mq--l"}`}>
              {(rev ? [...dynamicSponsors].reverse() : dynamicSponsors)
                .concat(rev ? [...dynamicSponsors].reverse() : dynamicSponsors)
                .map((s, i) => (
                  <div key={`mqcard-${ri}-${i}`} className="th-mq-card">
                    <div className="th-mq-logo" style={{ background: s.bg, overflow: "hidden" }}>
                      {s.logo
                        ? <img src={s.logo} alt={s.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} onError={e => { e.target.style.display = "none"; }} />
                        : s.letter}
                    </div>
                    <div><div className="th-mq-name">{s.name}</div><div className="th-mq-jobs">{s.jobs}</div></div>
                  </div>
                ))}
            </div>
          </div>
        ))}
        {sponsorsLoading && (
          <div style={{ textAlign: "center", padding: "32px 0", color: "#9ca3af", fontSize: "0.88rem" }}>
            Loading partners…
          </div>
        )}
      </div>

      {/* ═══ EARN REWARDS ═══ */}
      <EarnRewardsSection navigate={navigate} isLoggedIn={isLoggedIn} authLoading={authLoading} authUser={user} />

      {/* ═══ POPULAR ROLES ═══ */}
      <section className="th-section th-section--soft head-th-slide" style={{ backgroundColor: "rgba(255, 255, 255, 0.99)", border: "none" }}>
        <div className="th-container">
          <div className="th-sh" data-aos="fade-up" data-aos-delay="0">
            <h2 className="th-sh-title">Jobs Across <span className="th-grad">Popular Roles</span></h2>
            <p className="th-sh-sub">Thousands of live openings across every industry and function.</p>
          </div>
          <div className="th-roles-grid">
            {rolesLoading
              ? Array.from({ length: 12 }).map((_, i) => (
                  <div key={`rskel-${i}`} className="th-role-chip" style={{ pointerEvents: "none" }}>
                    <div className="cc-skel" style={{ width: "100%", height: 56, borderRadius: 12 }} />
                  </div>
                ))
              : dynamicRoles.map((r, i) => (
                  <div
                    key={`role-${i}`}
                    className="th-role-chip"
                    data-aos={aosDir(i)}
                    data-aos-delay={aosDelay(i, 45)}
                    onClick={e => { spawnScore(e, "+10 XP"); navigate(`/employee/jobs?keyword=${encodeURIComponent(r.role)}`); }}
                    onKeyDown={e => { if (e.key === "Enter") navigate(`/employee/jobs?keyword=${encodeURIComponent(r.role)}`); }}
                    onMouseEnter={e => showTip(`Browse ${r.count} for ${r.role}`, e)}
                    onMouseMove={e => moveTip(`Browse ${r.count} for ${r.role}`, e)}
                    onMouseLeave={hideTip}
                    role="button"
                    tabIndex={0}
                  >
                    <span className="th-role-chip__icon"><RoleIcon iconName={r.icon} size={20} color="#263012" /></span>
                    <div><span className="th-role-chip__name">{r.role}</span><span className="th-role-chip__count">{r.count}</span></div>
                    <span className="th-role-chip__arrow"><Icons.ArrowRight size={14} color="#9ca3af" /></span>
                  </div>
                ))
            }
          </div>
        </div>
      </section>

      {/* ═══ INTERVIEW Q&A ═══ */}
      <section className="th-section th-section--white head-th-slide">
        <div className="th-container">
          <div className="th-sh" data-aos="fade-up" data-aos-delay="0">
            <h2 className="th-sh-title">Ace Your <span className="th-grad">Interviews</span></h2>
            <p className="th-sh-sub">Thousands of real questions from top companies.</p>
          </div>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 28 }} data-aos="fade-up" data-aos-delay="80">
            <div className="th-iq-toggle">
              <button className={`th-iq-tab${iqTab === "company" ? " th-iq-tab--active" : ""}`} onClick={() => setIqTab("company")}>
                <Icons.Briefcase size={13} color={iqTab === "company" ? "#263012" : "#9ca3af"} /> By Company
              </button>
              <button className={`th-iq-tab${iqTab === "role" ? " th-iq-tab--active" : ""}`} onClick={() => setIqTab("role")}>
                <Icons.Target size={13} color={iqTab === "role" ? "#263012" : "#9ca3af"} /> By Role
              </button>
            </div>
          </div>
          <div className="th-interview-grid">
            <div className="th-iq-block th-iq-panel" data-aos="fade-up" data-aos-delay="100"
              style={{ gridColumn: "1 / -1", maxWidth: 640, margin: "0 auto", width: "100%" }}>
              <div className="th-iq-heading">{iqTab === "company" ? "By Company" : "By Role"}</div>
              <div className="th-iq-list">
                {(iqTab === "company" ? INTERVIEW_COMPANY : INTERVIEW_ROLE).map((it, i) => (
                  <div
                    key={`iq-${i}`}
                    className="th-iq-item"
                    data-aos={aosDir(i)}
                    data-aos-delay={aosDelay(i, 55)}
                    onClick={() => navigate(
                      iqTab === "company"
                        ? `/employee/interview-questions?company=${encodeURIComponent(it.name)}`
                        : `/employee/interview-questions?role=${encodeURIComponent(it.name)}`
                    )}
                    onKeyDown={e => {
                      if (e.key === "Enter") navigate(
                        iqTab === "company"
                          ? `/employee/interview-questions?company=${encodeURIComponent(it.name)}`
                          : `/employee/interview-questions?role=${encodeURIComponent(it.name)}`
                      );
                    }}
                    role="button"
                    tabIndex={0}
                  >
                    <div className="th-iq-logo" style={{ background: it.bg }}>{it.l}</div>
                    <div>
                      <div className="th-iq-name">{it.name}</div>
                      <div className="th-iq-count">{it.count}</div>
                    </div>
                    <span className="th-iq-arrow"><Icons.ArrowRight size={14} color="#9ca3af" /></span>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 18 }}>
                <button className="th-btn-ghost" style={{ width: "100%", justifyContent: "center" }}
                  onClick={() => navigate("/employee/interview-questions")}>
                  View All Questions <Icons.ArrowRight size={14} color="#6b7280" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {scores.map(s => (
        <ScorePopup key={s.id} x={s.x} y={s.y} text={s.text} onDone={() => setScores(p => p.filter(x => x.id !== s.id))} />
      ))}
      <CursorTooltip tip={cursorTip} />
    </div>
  );
}